(() => {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("4dCyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $312648e4d50ce900$var$_viewMessage = $312648e4d50ce900$var$_interopRequireDefault((parcelRequire("arP3R")));
function $312648e4d50ce900$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $312648e4d50ce900$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $312648e4d50ce900$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $312648e4d50ce900$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $312648e4d50ce900$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $312648e4d50ce900$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $312648e4d50ce900$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $312648e4d50ce900$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $312648e4d50ce900$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $312648e4d50ce900$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $312648e4d50ce900$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $312648e4d50ce900$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $312648e4d50ce900$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $312648e4d50ce900$var$_parsed = /*#__PURE__*/ new WeakMap();
var $312648e4d50ce900$var$_viewMessages = /*#__PURE__*/ new WeakMap();
var $312648e4d50ce900$var$_$wrap = /*#__PURE__*/ new WeakMap();
class $312648e4d50ce900$var$ViewMessages {
    get empty() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_parsed) == null;
    }
    get parsed() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_parsed);
    }
    constructor(){
        $312648e4d50ce900$var$_classPrivateFieldInitSpec(this, $312648e4d50ce900$var$_parsed, {
            writable: true,
            value: void 0
        });
        $312648e4d50ce900$var$_classPrivateFieldInitSpec(this, $312648e4d50ce900$var$_viewMessages, {
            writable: true,
            value: void 0
        });
        $312648e4d50ce900$var$_classPrivateFieldInitSpec(this, $312648e4d50ce900$var$_$wrap, {
            writable: true,
            value: void 0
        });
        $312648e4d50ce900$var$_classPrivateFieldSet(this, $312648e4d50ce900$var$_viewMessages, new Map());
    }
    parse(messages) {
        if (messages) {
            $312648e4d50ce900$var$_classPrivateFieldSet(this, $312648e4d50ce900$var$_parsed, JSON.parse(messages));
            Object.values($312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_parsed)).forEach((message)=>{
                const vm = new $312648e4d50ce900$var$_viewMessage.default(message);
                $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).set(vm.type, vm);
            });
        }
    }
    display($container) {
        if (!$container) $container = $("body");
        $312648e4d50ce900$var$_classPrivateFieldSet(this, $312648e4d50ce900$var$_$wrap, $container.find(".view-msg-wrap"));
        $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).forEach((viewMessage)=>{
            viewMessage.display($container);
        });
    }
    scrollTo() {
        window.scroller.scrollToElemTop($312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_$wrap));
    }
    clear($container) {
        const $wrap = $container.find(".view-msg-wrap");
        $wrap.empty();
    }
    hasAlert() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).has("alert");
    }
    hasWarning() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).has("warning");
    }
    hasInfo() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).has("info");
    }
    getAlert() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).get("alert");
    }
    getWarning() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).get("warning");
    }
    getInfo() {
        return $312648e4d50ce900$var$_classPrivateFieldGet(this, $312648e4d50ce900$var$_viewMessages).get("info");
    }
}
module.exports.default = $312648e4d50ce900$var$ViewMessages;

});
parcelRequire.register("arP3R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $79b408b7e8626c52$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $79b408b7e8626c52$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $79b408b7e8626c52$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $79b408b7e8626c52$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $79b408b7e8626c52$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $79b408b7e8626c52$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $79b408b7e8626c52$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $79b408b7e8626c52$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $79b408b7e8626c52$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $79b408b7e8626c52$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $79b408b7e8626c52$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $79b408b7e8626c52$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $79b408b7e8626c52$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $79b408b7e8626c52$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $79b408b7e8626c52$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $79b408b7e8626c52$var$_type = /*#__PURE__*/ new WeakMap();
var $79b408b7e8626c52$var$_header = /*#__PURE__*/ new WeakMap();
var $79b408b7e8626c52$var$_body = /*#__PURE__*/ new WeakMap();
var $79b408b7e8626c52$var$_getMarkup = /*#__PURE__*/ new WeakSet();
class $79b408b7e8626c52$var$ViewMessage {
    get type() {
        return $79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_type);
    }
    get header() {
        return $79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_header);
    }
    get body() {
        return $79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_body);
    }
    constructor(_ref){
        let type = _ref.type, header = _ref.header, body = _ref.body;
        $79b408b7e8626c52$var$_classPrivateMethodInitSpec(this, $79b408b7e8626c52$var$_getMarkup);
        $79b408b7e8626c52$var$_classPrivateFieldInitSpec(this, $79b408b7e8626c52$var$_type, {
            writable: true,
            value: void 0
        });
        $79b408b7e8626c52$var$_classPrivateFieldInitSpec(this, $79b408b7e8626c52$var$_header, {
            writable: true,
            value: void 0
        });
        $79b408b7e8626c52$var$_classPrivateFieldInitSpec(this, $79b408b7e8626c52$var$_body, {
            writable: true,
            value: void 0
        });
        $79b408b7e8626c52$var$_classPrivateFieldSet(this, $79b408b7e8626c52$var$_type, type);
        $79b408b7e8626c52$var$_classPrivateFieldSet(this, $79b408b7e8626c52$var$_header, header);
        $79b408b7e8626c52$var$_classPrivateFieldSet(this, $79b408b7e8626c52$var$_body, body);
    }
    display($container) {
        if (!$container) $container = $("body");
        const $wrap = $container.find(".view-msg-wrap");
        let $elements = $wrap.find(`.msg-${$79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_type)}`);
        // Create a new elemnt if the original was dismissed
        if ($elements.length == 0) {
            $elements = $79b408b7e8626c52$var$_classPrivateMethodGet(this, $79b408b7e8626c52$var$_getMarkup, $79b408b7e8626c52$var$_getMarkup2).call(this);
            $wrap.append($elements);
        }
        $elements.empty();
        const $header = $("<span class='text-semibold' />");
        $header.html($79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_header));
        // Drop duplicated full stops at the end of the body
        if ($79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_body).slice(-2) === "..") $79b408b7e8626c52$var$_classPrivateFieldSet(this, $79b408b7e8626c52$var$_body, $79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_body).slice(0, -1));
        const $body = $("<p />");
        $body.html($79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_body));
        if ($elements.hasClass("alert-dismissable")) $elements.append($("<button class='close' data-dismiss='alert'>&times;</button>"));
        $elements.append($header).append($body);
        $elements.fadeIn();
    }
}
module.exports.default = $79b408b7e8626c52$var$ViewMessage;
function $79b408b7e8626c52$var$_getMarkup2() {
    return $(`<div role="alert" class="msg-${$79b408b7e8626c52$var$_classPrivateFieldGet(this, $79b408b7e8626c52$var$_type)} alert alert-danger alert-dismissable"></div>`);
}

});


parcelRequire.register("5BUQw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
class $415c80e2d5e96556$var$BlockUI {
    static blockWithId(elemId, msg) {
        const $elem = $(`#${elemId}`);
        $415c80e2d5e96556$var$BlockUI.blockElem($elem, msg);
    }
    static unblockWithId(elemId) {
        const $elem = $(`#${elemId}`);
        $415c80e2d5e96556$var$BlockUI.unblockElem($elem);
    }
    static blockElem(elem, msg) {
        const $elem = elem instanceof jQuery ? elem : $(elem);
        $elem.block($415c80e2d5e96556$var$BlockUI.defaultOptions(msg));
    }
    static unblockElem(elem) {
        const $elem = elem instanceof jQuery ? elem : $(elem);
        $elem.unblock();
    }
    static blockPage(msg) {
        $.blockUI($415c80e2d5e96556$var$BlockUI.defaultOptions(msg));
    }
    static unblockPage() {
        $.unblockUI();
    }
    static defaultOptions() {
        let msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Loading...";
        return {
            message: `<i class="fa fa-gear fa-spin fa-2x"></i><span class="block-ui">&nbsp;${msg}</span>`,
            overlayCSS: {
                backgroundColor: "var(--bs-light)",
                opacity: 0.6,
                cursor: "wait"
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: "transparent"
            }
        };
    }
}
module.exports.default = $415c80e2d5e96556$var$BlockUI;

});

parcelRequire.register("bqdsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $850c8f653bc5590f$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $850c8f653bc5590f$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $850c8f653bc5590f$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $850c8f653bc5590f$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $850c8f653bc5590f$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $850c8f653bc5590f$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $850c8f653bc5590f$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $850c8f653bc5590f$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $850c8f653bc5590f$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $850c8f653bc5590f$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $850c8f653bc5590f$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $850c8f653bc5590f$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $850c8f653bc5590f$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $850c8f653bc5590f$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $850c8f653bc5590f$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $850c8f653bc5590f$var$_ui = /*#__PURE__*/ new WeakMap();
var $850c8f653bc5590f$var$_currentTab = /*#__PURE__*/ new WeakMap();
var $850c8f653bc5590f$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $850c8f653bc5590f$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $850c8f653bc5590f$var$_showFirstOrInvalidTab = /*#__PURE__*/ new WeakSet();
var $850c8f653bc5590f$var$_showTab = /*#__PURE__*/ new WeakSet();
var $850c8f653bc5590f$var$_showNextPrev = /*#__PURE__*/ new WeakSet();
class $850c8f653bc5590f$var$MultiPageRegisterForm {
    get eventTarget() {
        return $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).form;
    }
    get form() {
        return $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).form;
    }
    constructor(){
        $850c8f653bc5590f$var$_classPrivateMethodInitSpec(this, $850c8f653bc5590f$var$_showNextPrev);
        $850c8f653bc5590f$var$_classPrivateMethodInitSpec(this, $850c8f653bc5590f$var$_showTab);
        $850c8f653bc5590f$var$_classPrivateMethodInitSpec(this, $850c8f653bc5590f$var$_showFirstOrInvalidTab);
        $850c8f653bc5590f$var$_classPrivateMethodInitSpec(this, $850c8f653bc5590f$var$_bindEvents);
        $850c8f653bc5590f$var$_classPrivateMethodInitSpec(this, $850c8f653bc5590f$var$_cacheUiElements);
        $850c8f653bc5590f$var$_classPrivateFieldInitSpec(this, $850c8f653bc5590f$var$_ui, {
            writable: true,
            value: void 0
        });
        $850c8f653bc5590f$var$_classPrivateFieldInitSpec(this, $850c8f653bc5590f$var$_currentTab, {
            writable: true,
            value: void 0
        });
        $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_currentTab, 0);
    }
    init() {
        $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_cacheUiElements, $850c8f653bc5590f$var$_cacheUiElements2).call(this);
        $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_bindEvents, $850c8f653bc5590f$var$_bindEvents2).call(this);
        $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_showFirstOrInvalidTab, $850c8f653bc5590f$var$_showFirstOrInvalidTab2).call(this);
    }
}
module.exports.default = $850c8f653bc5590f$var$MultiPageRegisterForm;
function $850c8f653bc5590f$var$_cacheUiElements2() {
    $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_ui, {
        form: $("form"),
        tabs: $("form").find(".tab"),
        previousButton: $("input#previous"),
        nextButton: $("input#next"),
        registerButton: $("input#register")
    });
}
function $850c8f653bc5590f$var$_bindEvents2() {
    $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).previousButton.on("click", (e)=>{
        e.preventDefault();
        $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_showNextPrev, $850c8f653bc5590f$var$_showNextPrev2).call(this, -1);
    });
    $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).nextButton.on("click", (e)=>{
        e.preventDefault();
        $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).form.validate();
        if ($850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).form.valid()) $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_showNextPrev, $850c8f653bc5590f$var$_showNextPrev2).call(this, 1);
    });
}
function $850c8f653bc5590f$var$_showFirstOrInvalidTab2() {
    let isErrors = false;
    $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_currentTab, $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.length - 1);
    $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.find(".validation-field.field-validation-error").each((index, element)=>{
        isErrors = true;
        const $tab = $(element).parents(".tab");
        if ($tab.index() < $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_currentTab)) $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_currentTab, $tab.index());
    });
    // Go to the first page if there were no errors
    if (!isErrors) $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_currentTab, 0);
    $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_showTab, $850c8f653bc5590f$var$_showTab2).call(this, $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_currentTab));
}
function $850c8f653bc5590f$var$_showTab2(index) {
    $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.eq(index).removeClass("hidden");
    if (index === 0) $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).previousButton.addClass("hidden");
    else $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).previousButton.removeClass("hidden");
    if (index === $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.length - 1) {
        $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).nextButton.addClass("hidden");
        $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).registerButton.removeClass("hidden").attr("disabled", false);
    } else {
        $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).nextButton.removeClass("hidden");
        $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).registerButton.addClass("hidden").attr("disabled", true);
    }
    // Focus the first focusable element:
    $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.eq(index).find("button, a, input, select, textarea, [tabindex]:not([tabindex='-1'])").eq(0).focus();
}
function $850c8f653bc5590f$var$_showNextPrev2(n) {
    $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.eq($850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_currentTab)).addClass("hidden");
    $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_currentTab, $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_currentTab) + n);
    if ($850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_currentTab) >= $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.length) {
        $850c8f653bc5590f$var$_classPrivateFieldSet(this, $850c8f653bc5590f$var$_currentTab, $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_ui).tabs.length);
        return;
    }
    $850c8f653bc5590f$var$_classPrivateMethodGet(this, $850c8f653bc5590f$var$_showTab, $850c8f653bc5590f$var$_showTab2).call(this, $850c8f653bc5590f$var$_classPrivateFieldGet(this, $850c8f653bc5590f$var$_currentTab));
    this.eventTarget.trigger("next-prev.register-form");
}

});

parcelRequire.register("t9g9T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0579e45100c644f0$var$_appointmentList2 = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("9b61C")));

var $0579e45100c644f0$var$_appointmentCard2 = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("ayFEK")));

var $0579e45100c644f0$var$_appointmentsService = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("bPqot")));

var $0579e45100c644f0$var$_blockUi = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("5BUQw")));

var $0579e45100c644f0$var$_loginModal = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("gdohi")));

var $0579e45100c644f0$var$_paymentModal = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("bvkTP")));

var $0579e45100c644f0$var$_messagePoster = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("o3NoA")));

var $0579e45100c644f0$var$_termsModal = $0579e45100c644f0$var$_interopRequireDefault((parcelRequire("jwHwL")));

var $h7UYA = parcelRequire("h7UYA");
function $0579e45100c644f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0579e45100c644f0$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $0579e45100c644f0$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $0579e45100c644f0$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $0579e45100c644f0$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $0579e45100c644f0$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $0579e45100c644f0$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $0579e45100c644f0$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $0579e45100c644f0$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $0579e45100c644f0$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $0579e45100c644f0$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $0579e45100c644f0$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $0579e45100c644f0$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $0579e45100c644f0$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $0579e45100c644f0$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $0579e45100c644f0$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $0579e45100c644f0$var$_theme = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_appointmentList = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_appointmentCard = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_ui = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_selectedProvider = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_selectedTreatment = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_selectedDate = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_searchingMsg = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_defaultSelectAllProviders = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_animBorder = /*#__PURE__*/ new WeakMap();
var $0579e45100c644f0$var$_setCsrfToken = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_initSelectElements = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_getAppointments = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_bookAppointment = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_scrollToContent = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_highlightElem = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_formatProviderDropdown = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_formatTreatmentSelection = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_formatTreatmentDropdown = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_getTreatmentSelectionElement = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_preselectDefaultProvider = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_selectProvider = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_selectTreatment = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_updateProviders = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_requestBookingTermsAcceptance = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_beginBooking = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_requestDepositIfNeeded = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_requestPayment = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_requestLogin = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_getPaymentDetails = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_confirmAppointment = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_handleGetAppointmentsRequestError = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_handleConfirmAppointmentRequestError = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_handleBookingTermsError = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_handleBeginBookingError = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_handleRequestDepositError = /*#__PURE__*/ new WeakSet();
var $0579e45100c644f0$var$_handleBookingSessionError = /*#__PURE__*/ new WeakSet();
class $0579e45100c644f0$var$Schedule {
    constructor(options){
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_handleBookingSessionError);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_handleRequestDepositError);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_handleBeginBookingError);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_handleBookingTermsError);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_handleConfirmAppointmentRequestError);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_handleGetAppointmentsRequestError);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_confirmAppointment);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_getPaymentDetails);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_requestLogin);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_requestPayment);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_requestDepositIfNeeded);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_beginBooking);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_requestBookingTermsAcceptance);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_updateProviders);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_selectTreatment);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_selectProvider);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_preselectDefaultProvider);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_getTreatmentSelectionElement);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_formatTreatmentDropdown);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_formatTreatmentSelection);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_formatProviderDropdown);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_highlightElem);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_scrollToContent);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_bookAppointment);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_getAppointments);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_bindEvents);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_cacheUiElements);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_initSelectElements);
        $0579e45100c644f0$var$_classPrivateMethodInitSpec(this, $0579e45100c644f0$var$_setCsrfToken);
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_theme, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_appointmentList, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_appointmentCard, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_ui, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_selectedProvider, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_selectedTreatment, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_selectedDate, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_searchingMsg, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_defaultSelectAllProviders, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldInitSpec(this, $0579e45100c644f0$var$_animBorder, {
            writable: true,
            value: void 0
        });
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_theme, options.theme);
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_defaultSelectAllProviders, options.defaultSelectAllProviders);
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_appointmentList, new $0579e45100c644f0$var$_appointmentList2.default());
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_appointmentCard, new $0579e45100c644f0$var$_appointmentCard2.default());
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_selectedProvider, "");
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_selectedTreatment, "");
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_searchingMsg, "Searching...<br>Please wait...");
    }
    async init() {
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_setCsrfToken, $0579e45100c644f0$var$_setCsrfToken2).call(this);
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_initSelectElements, $0579e45100c644f0$var$_initSelectElements2).call(this);
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_cacheUiElements, $0579e45100c644f0$var$_cacheUiElements2).call(this);
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).init();
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentCard).init();
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_bindEvents, $0579e45100c644f0$var$_bindEvents2).call(this);
        // Messages are attached to the schedule element itself 
        // as the Book page is a SPA and the body is not refreshed.
        window.displayViewMessages($("#schedule").attr("data-messages"));
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_animBorder, new $h7UYA.AnimatedBorder());
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_highlightElem, $0579e45100c644f0$var$_highlightElem2).call(this, $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).treatment.select2);
    }
}
module.exports.default = $0579e45100c644f0$var$Schedule;
function $0579e45100c644f0$var$_setCsrfToken2() {
    const csrfToken = $("#csrf-token").attr("data-token");
    $0579e45100c644f0$var$_appointmentsService.default.setCsrfToken(csrfToken);
}
function $0579e45100c644f0$var$_initSelectElements2() {
    $("#treatment-select").select2({
        forceDropdownPosition: "below",
        selectionCssClass: `theme--${$0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_theme)}`,
        dropdownCssClass: `theme--${$0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_theme)}`,
        minimumResultsForSearch: Infinity,
        templateSelection: $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_formatTreatmentSelection, $0579e45100c644f0$var$_formatTreatmentSelection2).bind(this),
        templateResult: $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_formatTreatmentDropdown, $0579e45100c644f0$var$_formatTreatmentDropdown2).bind(this),
        width: "style",
        placeholder: "Select treatment from list"
    });
    $("#provider-select").select2({
        forceDropdownPosition: "below",
        selectionCssClass: `theme--${$0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_theme)}`,
        dropdownCssClass: `provider theme--${$0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_theme)}`,
        minimumResultsForSearch: Infinity,
        templateResult: $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_formatProviderDropdown, $0579e45100c644f0$var$_formatProviderDropdown2).bind(this),
        width: "style",
        placeholder: "Select provider from list"
    });
    $(".select2-container").addClass("form-select");
}
function $0579e45100c644f0$var$_cacheUiElements2() {
    $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_ui, {
        content: $("#content"),
        navbar: $("#nav-wrap"),
        provider: {
            wrap: $("#select-provider-wrap"),
            select: $("#provider-select"),
            select2: $("#select-provider-wrap .select2"),
            options: $("#provider-select option:not(:disabled)")
        },
        treatment: {
            wrap: $("#select-treatment-wrap"),
            select: $("#treatment-select"),
            select2: $("#select-treatment-wrap .select2")
        },
        appointment: {
            datePicker: $("#earliest-date-picker"),
            list: $("#select-appointment-wrap .card"),
            confirm: $("#appointment-selected")
        }
    });
}
function $0579e45100c644f0$var$_bindEvents2() {
    // Treatment selection handler.
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).treatment.select.change(async ()=>{
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.wrap.removeClass("hidden");
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_selectTreatment, $0579e45100c644f0$var$_selectTreatment2).call(this);
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).reset();
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).clear();
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentCard).deselect();
        window.scroller.scrollToElemTop($0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.wrap);
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_highlightElem, $0579e45100c644f0$var$_highlightElem2).call(this, $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select2);
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_preselectDefaultProvider, $0579e45100c644f0$var$_preselectDefaultProvider2).call(this);
    });
    // Provider selection handler.
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.change(async ()=>{
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentCard).deselect();
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_selectProvider, $0579e45100c644f0$var$_selectProvider2).call(this);
    });
    // Clicking anywhere in the selection wrap should open the dropdown.
    $(".select-wrap").on("click", (e)=>{
        e.stopPropagation();
        const $this = $(e.currentTarget);
        $this.find("select").select2("open");
    });
    // Resize the window when select elements are clicked to ensure they are not hidden.
    $("select").on("select2:open", (e)=>{
        const $select = $(e.currentTarget);
        // If the select2 sibling is currently animated, pause the animation
        if ($select.siblings(".anim-border").length > 0) $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_animBorder).pause();
        const $dropdown = $select.data("select2").$results;
        window.resizer.fitElem($dropdown);
    });
    // Resize the window when select elements are closed to remove empty space
    $("select").on("select2:close", (e)=>{
        const $select = $(e.currentTarget);
        // If the select2 sibling is currently animated, resume the animation
        if ($select.siblings(".anim-border").length > 0) $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_animBorder).play();
        window.resizer.fitElem($("body"));
    });
    // Get appointments when appointments list navigated.
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).eventTarget.on("change.appointment-list", async (e, date)=>{
        $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_selectedDate, date);
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getAppointments, $0579e45100c644f0$var$_getAppointments2).call(this);
    });
    // Update appointment card when appointment selected from list.
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).eventTarget.on("select.appointment-list", (e, appointment)=>{
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentCard).select(appointment);
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_highlightElem, $0579e45100c644f0$var$_highlightElem2).call(this, $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).appointment.confirm);
    });
    // Confirm the selected appointment on confirm clicked.
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentCard).eventTarget.on("confirm.appointment-card", (e, details)=>{
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_bookAppointment, $0579e45100c644f0$var$_bookAppointment2).call(this, details);
    });
}
async function $0579e45100c644f0$var$_getAppointments2() {
    if ($0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_selectedTreatment) === "" || $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_selectedProvider) === "") return;
    $0579e45100c644f0$var$_blockUi.default.blockWithId("appointment-details-card", $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_searchingMsg));
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentCard).deselect();
    let data;
    try {
        data = await $0579e45100c644f0$var$_appointmentsService.default.getAppointments($0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_selectedProvider), $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_selectedTreatment), $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_selectedDate), window.customerConfig.toQueryString());
    } catch (errResp) {
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleGetAppointmentsRequestError, $0579e45100c644f0$var$_handleGetAppointmentsRequestError2).call(this, errResp);
        return;
    } finally{
        $0579e45100c644f0$var$_blockUi.default.unblockWithId("appointment-details-card");
    }
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).show(data);
    $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_highlightElem, $0579e45100c644f0$var$_highlightElem2).call(this, $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).appointment.list);
}
async function $0579e45100c644f0$var$_bookAppointment2(_ref) {
    let id = _ref.id, deposit = _ref.deposit, note = _ref.note;
    $0579e45100c644f0$var$_blockUi.default.blockWithId("schedule", "Working...<br>Please wait...");
    try {
        // Handle booking terms acceptance
        try {
            await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_requestBookingTermsAcceptance, $0579e45100c644f0$var$_requestBookingTermsAcceptance2).call(this, id);
        } catch (error) {
            $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingTermsError, $0579e45100c644f0$var$_handleBookingTermsError2).call(this, error);
            return;
        }
        // Start the booking process
        let bookingStarted = false;
        try {
            bookingStarted = await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_beginBooking, $0579e45100c644f0$var$_beginBooking2).call(this, id, note);
        } catch (error) {
            $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBeginBookingError, $0579e45100c644f0$var$_handleBeginBookingError2).call(this, error);
            return;
        }
        // If the booking didn't start then exit here,
        // any error should have been handled already
        if (!bookingStarted) return;
        // Handle deposit payment
        try {
            await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_requestDepositIfNeeded, $0579e45100c644f0$var$_requestDepositIfNeeded2).call(this, deposit);
        } catch (error) {
            $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleRequestDepositError, $0579e45100c644f0$var$_handleRequestDepositError2).call(this, error);
            return;
        }
        // Handle appointment booking
        let data;
        try {
            data = await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_confirmAppointment, $0579e45100c644f0$var$_confirmAppointment2).call(this);
        } catch (errResp) {
            await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleConfirmAppointmentRequestError, $0579e45100c644f0$var$_handleConfirmAppointmentRequestError2).call(this, errResp, {
                id: id,
                note: note,
                note: note
            });
            return;
        }
        if (data) {
            // The appointment is booked.
            // Post booked message to parent
            $0579e45100c644f0$var$_messagePoster.default.postBookingStatusBooked(data);
            // Display the booking confirmation
            window.customerConfig.returnUrl = "/Book";
            window.pageRouter.load(`/Book/Confirmation?${window.customerConfig.toQueryString()}`);
        }
    } finally{
        $0579e45100c644f0$var$_blockUi.default.unblockWithId("schedule");
    }
}
function $0579e45100c644f0$var$_scrollToContent2() {
    window.scroller.scrollToElemTop($0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).content);
}
function $0579e45100c644f0$var$_highlightElem2($elem) {
    // Wait for the next frame to ensure any dom changes have been redrawn
    setTimeout(()=>{
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_animBorder).remove();
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_animBorder).attach($elem);
    }, 1);
}
function $0579e45100c644f0$var$_formatProviderDropdown2(provider) {
    if (!provider.id) return provider.text;
    const baseUrl = "/Image/Provider";
    let cleanProvider = DOMPurify.sanitize(provider.id);
    const cleanVersion = DOMPurify.sanitize($(provider.element).attr("data-photo-v"));
    const cleanText = DOMPurify.sanitize(provider.text);
    const rawTitle = $(provider.element).attr("data-professional-title");
    let cleanTitle = DOMPurify.sanitize(rawTitle);
    if (!cleanTitle) {
        const rawType = $(provider.element).attr("data-type");
        cleanTitle = DOMPurify.sanitize(rawType);
        // We don't need to show the `Any` type
        if (cleanTitle === "Any") cleanTitle = "";
        else if (cleanTitle === "Therapist") cleanTitle = "Dental Therapist";
    }
    const $provider = $(`<div class="provider d-flex align-items-center">
      <img src="" class="thumbnail" />
      <div>
      <div class="name">${cleanText}</div>
      <div class="title">${cleanTitle}</div>
      </div>
      </div>`);
    const $img = $provider.find("img");
    // If provider is not a specific id ("any") request the "any" image.
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(cleanProvider)) cleanProvider = "any";
    let src = `${baseUrl}/${cleanProvider}`;
    if (cleanVersion) src += `?v=${cleanVersion}`;
    $img.attr("src", src);
    if (cleanProvider === "any") $img.addClass("small");
    return $provider;
}
function $0579e45100c644f0$var$_formatTreatmentSelection2(treatment) {
    if (!treatment.id) return treatment.text;
    const $treatment = $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getTreatmentSelectionElement, $0579e45100c644f0$var$_getTreatmentSelectionElement2).call(this, treatment);
    $treatment.addClass("selection");
    return $treatment;
}
function $0579e45100c644f0$var$_formatTreatmentDropdown2(treatment) {
    if (!treatment.id) return treatment.text;
    const rawAdditional = $(treatment.element).attr("data-additional");
    const cleanAdditional = DOMPurify.sanitize(rawAdditional);
    const $treatment = $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getTreatmentSelectionElement, $0579e45100c644f0$var$_getTreatmentSelectionElement2).call(this, treatment);
    const $additional = $(`<div class="add w-100">${cleanAdditional}</div>`);
    $treatment.append($additional).addClass("results");
    return $treatment;
}
function $0579e45100c644f0$var$_getTreatmentSelectionElement2(treatment) {
    const $treatmentOption = $(treatment.element);
    const rawDuration = $treatmentOption.attr("data-duration");
    const rawPrice = $treatmentOption.attr("data-price");
    const rawDiscount = $treatmentOption.attr("data-discount-price");
    const rawDeposit = $treatmentOption.attr("data-deposit");
    const cleanText = DOMPurify.sanitize(treatment.text);
    const cleanDuration = DOMPurify.sanitize(rawDuration);
    const cleanPrice = DOMPurify.sanitize(rawPrice);
    const cleanDiscount = DOMPurify.sanitize(rawDiscount);
    const cleanDeposit = DOMPurify.sanitize(rawDeposit);
    const $treatment = $(`<div class="treatment d-flex flex-wrap justify-content-between align-items-baseline">
      <span class="type flex-grow-1">${cleanText}</span>
      </div>`);
    const $tags = $(`<span class="d-flex tags flex-wrap justify-content-start mr-auto"></span>`);
    if (cleanDiscount && cleanPrice) $tags.append(`<span class="price tag">` + `<span class="sr-only">Price:&nbsp;</span>${cleanDiscount}&nbsp;` + `<span class="old-price">Was:&nbsp<span class="text-decoration-line-through">${cleanPrice}</span>` + `</span></span>`);
    else if (cleanPrice) $tags.append(`<span class="price tag">${cleanPrice}</span>`);
    if (cleanDeposit) $tags.append(`<span class="deposit tag">Deposit:&nbsp;${cleanDeposit}</span>`);
    if (cleanDuration) $tags.append(`<span class="tag">${cleanDuration}&nbsp;mins</span>`);
    $treatment.append($tags);
    return $treatment;
}
function $0579e45100c644f0$var$_preselectDefaultProvider2() {
    const $providers = $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.find("option").not(":disabled");
    // Select first provider if they are the one.
    if ($providers.length === 1) {
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.val($providers.first().val());
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.trigger("change");
    } else if ($0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_defaultSelectAllProviders)) {
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.val("any");
        $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.trigger("change");
    }
// Otherwise don't preselect an option
}
function $0579e45100c644f0$var$_selectProvider2() {
    $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_selectedProvider, $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.find("option:selected").val() ?? "");
    if ($0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_selectedProvider)) $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getAppointments, $0579e45100c644f0$var$_getAppointments2).call(this);
}
function $0579e45100c644f0$var$_selectTreatment2() {
    const $treatmentOption = $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).treatment.select.find("option:selected").first();
    $0579e45100c644f0$var$_classPrivateFieldSet(this, $0579e45100c644f0$var$_selectedTreatment, $treatmentOption.val() ?? "");
    const type = $treatmentOption.attr("data-type");
    $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_updateProviders, $0579e45100c644f0$var$_updateProviders2).call(this, type);
}
function $0579e45100c644f0$var$_updateProviders2(treatmentType) {
    // treatmentType is a comma separated list of compatible provider types
    let compatibleTypes = treatmentType.split(",");
    compatibleTypes = compatibleTypes.map((t)=>t.trim());
    // Enable providers with a matching type
    let count = 0;
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.options.each((index, elem)=>{
        const $this = $(elem);
        const providerType = $this.attr("data-type");
        const enabled = providerType === "Any" || compatibleTypes.includes("Any") || compatibleTypes.includes(providerType);
        $this.attr("disabled", !enabled);
        $this.attr("hidden", !enabled);
        if (enabled && providerType !== "Any") count++;
    });
    // Hide "Any" option if less than two providers match
    if (count < 2) {
        const $any = $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.options.filter("option[value='any']");
        $any.attr("disabled", true);
        $any.attr("hidden", true);
    }
    // Reset the selection
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.val("");
    $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_ui).provider.select.trigger("change");
}
async function $0579e45100c644f0$var$_requestBookingTermsAcceptance2(id) {
    window.pageRouter.pauseLinkInterceptor();
    const modal = new $0579e45100c644f0$var$_termsModal.default();
    modal.init();
    try {
        await modal.requestAcceptance(id);
    } catch (error) {
        let message = "";
        if (error.message === "Booking terms closed.") message = error.message;
        else {
            console.error(error);
            message = "There was an error when trying to process your acceptance of the booking terms. Please try again.";
        }
        throw new Error(message);
    } finally{
        modal.close();
        window.pageRouter.resumeLinkInterceptor();
    }
}
async function $0579e45100c644f0$var$_beginBooking2(appointmentId, bookingNote) {
    try {
        await $0579e45100c644f0$var$_appointmentsService.default.beginBooking(appointmentId, bookingNote);
        return true;
    } catch (errResp) {
        switch(errResp.status){
            // Unauthorized 
            case 401:
                // Retry after logging in
                await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_requestLogin, $0579e45100c644f0$var$_requestLogin2).call(this);
                return await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_beginBooking, $0579e45100c644f0$var$_beginBooking2).call(this, appointmentId, bookingNote);
            // Redirect
            case 302:
                // If we are redirected replace the current content so we don't lose
                // our session when cookies are blocked.
                if (errResp.responseJSON.location.toLowerCase().startsWith("/book")) {
                    await window.pageRouter.load(errResp.responseJSON.location);
                    return false;
                }
                // Otherwise this is an unexpected redirect - don't follow it as we don't want to lose
                // our session if cookies are blocked.
                throw new Error(`Unexpected redirect to: ${errResp.responseJSON.location}. Redirect ignored.`);
            default:
                if ("responseText" in errResp && (errResp.responseText.includes("Booking limit reached") || errResp.responseText.includes("not currently accepting appointment bookings from you"))) throw new Error(errResp.responseText);
                throw new Error(`Could not create new booking. ${errResp.responseText}.`);
        }
    }
}
async function $0579e45100c644f0$var$_requestDepositIfNeeded2(deposit) {
    if (deposit > 0) {
        // Request the payment from the user
        const paymentDetails = await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getPaymentDetails, $0579e45100c644f0$var$_getPaymentDetails2).call(this);
        if (paymentDetails) await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_requestPayment, $0579e45100c644f0$var$_requestPayment2).call(this, paymentDetails);
    }
}
async function $0579e45100c644f0$var$_requestPayment2(paymentDetails) {
    const url = `${paymentDetails.gatewayUrl}?token=${paymentDetails.token}`;
    const modal = new $0579e45100c644f0$var$_paymentModal.default(url);
    try {
        await modal.requestPayment();
    } catch (error) {
        let message = "";
        if (error.message === "Payment cancelled.") message = error.message;
        else {
            console.error(error);
            message = "Could not process your payment, please try again.";
        }
        throw new Error(message);
    } finally{
        modal.close();
    }
// Payment success
}
async function $0579e45100c644f0$var$_requestLogin2() {
    window.pageRouter.pauseLinkInterceptor();
    const modal = new $0579e45100c644f0$var$_loginModal.default();
    modal.init();
    try {
        await modal.requestLogin();
    } catch (error) {
        let message = "";
        if (error.message === "Login cancelled.") message = error.message;
        else {
            console.error(error);
            message = "Could not log you in, please try again.";
        }
        throw new Error(message);
    } finally{
        modal.close();
        window.pageRouter.resumeLinkInterceptor();
    }
    // Login success
    await window.pageRouter.refreshNavbar();
}
async function $0579e45100c644f0$var$_getPaymentDetails2() {
    let paymentDetails;
    try {
        paymentDetails = await $0579e45100c644f0$var$_appointmentsService.default.getPaymentDetails();
    } catch (errResp) {
        switch(errResp.status){
            // Unauthorized 
            case 401:
                // Retry after logging in
                await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_requestLogin, $0579e45100c644f0$var$_requestLogin2).call(this);
                return await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getPaymentDetails, $0579e45100c644f0$var$_getPaymentDetails2).call(this);
            // Forbidden
            case 403:
                if ("responseText" in errResp && (errResp.responseText.includes("maximum number of appointments booked") || errResp.responseText.includes("not currently accepting appointment bookings from you"))) throw new Error(errResp.responseText);
        }
        // Otherwise throw a generic payment error
        throw new Error(`Could not get payment details. ${errResp.responseText}`);
    }
    return paymentDetails;
}
async function $0579e45100c644f0$var$_confirmAppointment2() {
    try {
        return await $0579e45100c644f0$var$_appointmentsService.default.confirmAppointment();
    } catch (errResp) {
        switch(errResp.status){
            // Unauthorized 
            case 401:
                // Retry after logging in
                await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_requestLogin, $0579e45100c644f0$var$_requestLogin2).call(this);
                return await $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_confirmAppointment, $0579e45100c644f0$var$_confirmAppointment2).call(this);
            // Forbidden
            case 403:
                if ("responseText" in errResp && (errResp.responseText.includes("maximum number of appointments booked") || errResp.responseText.includes("not currently accepting appointment bookings from you"))) throw new Error(errResp.responseText);
            // Gone
            case 410:
                throw new Error("Your chosen appointment time is no longer available. Please choose another time.");
            // Aborted
            case 0:
                throw new Error("The server could not be reached. Please try again later.");
            // Redirect
            case 302:
                // If we are redirected replace the current content so we don't lose
                // our session when cookies are blocked.
                if (errResp.responseJSON.location.toLowerCase().startsWith("/book")) {
                    await window.pageRouter.load(errResp.responseJSON.location);
                    // The booking wasn't confirmed;
                    return null;
                }
                // Otherwise this is an unexpected redirect - don't follow it as we don't want to lose
                // our session if cookies are blocked.
                throw new Error(`Unexpected redirect to: ${errResp.responseJSON.location}. Redirect ignored.`);
            default:
                if ("responseText" in errResp) // Handle booking session errors
                {
                    if (errResp.responseText.includes("Booking session timed out") || errResp.responseText.includes("Booking terms must be accepted")) {
                        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingSessionError, $0579e45100c644f0$var$_handleBookingSessionError2).call(this, errResp.responseText);
                        break;
                    }
                }
                throw new Error(`Could not create new booking. ${errResp.responseText}`);
        }
    }
}
async function $0579e45100c644f0$var$_handleGetAppointmentsRequestError2(errResp) {
    switch(errResp.status){
        // Aborted
        case 0:
            bootbox.alert({
                message: "The server could not be reached. Please try again later.",
                backdrop: true
            });
            break;
        default:
            {
                if ("responseText" in errResp && (errResp.responseText.includes("Booking session timed out") || errResp.responseText.includes("Booking terms must be accepted"))) {
                    $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingSessionError, $0579e45100c644f0$var$_handleBookingSessionError2).call(this, errResp.responseText);
                    break;
                }
                console.error(errResp.responseText);
                $0579e45100c644f0$var$_classPrivateFieldGet(this, $0579e45100c644f0$var$_appointmentList).clear();
                const msg = "There was an error requesting available appointments. Please try again.";
                bootbox.alert({
                    message: msg,
                    backdrop: true
                });
            }
    }
}
async function $0579e45100c644f0$var$_handleConfirmAppointmentRequestError2(error) {
    console.error(error);
    if (error.message.includes("Booking session timed out") || error.message.includes("Booking terms must be accepted")) {
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingSessionError, $0579e45100c644f0$var$_handleBookingSessionError2).call(this, error.message);
        return;
    }
    if (error.message.includes("appointment time is no longer available")) {
        bootbox.alert({
            message: error.message,
            backdrop: true
        });
        // Refresh the appointments list
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_getAppointments, $0579e45100c644f0$var$_getAppointments2).call(this);
        return;
    }
    let message;
    if (error.message.includes("maximum number of appointments booked") || error.message.includes("not currently accepting appointment bookings from you")) message = error.message;
    else if (error.message === "Login cancelled.") message = "Login cancelled. Please log in or register to book your appointment.";
    else if (error.message === "The server could not be reached.") message = "The server could not be reached. Please try again later.";
    else message = "There was a problem booking your appointment. <b>Please try again.</b><br /><br />If you have already paid a deposit you will not be asked to make another payment.<br />If this problem persists, please contact the practice.";
    bootbox.alert({
        message: message,
        backdrop: true
    });
}
function $0579e45100c644f0$var$_handleBookingTermsError2(error) {
    console.error(error);
    if (error.message.includes("Booking session timed out") || error.message.includes("Booking terms must be accepted")) {
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingSessionError, $0579e45100c644f0$var$_handleBookingSessionError2).call(this, error.message);
        return;
    }
    let message;
    if (error.message === "Booking terms closed.") message = "Booking terms declined. We cannot offer an appointment if the booking terms are not accepted.";
    else if (error.message === "The server could not be reached.") message = "The server could not be reached. Please try again later.";
    else message = "There was a problem with the appointment booking terms. Please try again.";
    bootbox.alert({
        message: message,
        backdrop: true
    });
    $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_scrollToContent, $0579e45100c644f0$var$_scrollToContent2).call(this);
}
function $0579e45100c644f0$var$_handleBeginBookingError2(error) {
    console.error(error);
    if (error.message.includes("Booking session timed out") || error.message.includes("Booking terms must be accepted")) {
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingSessionError, $0579e45100c644f0$var$_handleBookingSessionError2).call(this, error.message);
        return;
    }
    let message;
    if (error.message === "The server could not be reached.") message = "The server could not be reached. Please try again later.";
    else message = "There was a problem booking your appointment. Please try again.";
    bootbox.alert({
        message: message,
        backdrop: true
    });
    $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_scrollToContent, $0579e45100c644f0$var$_scrollToContent2).call(this);
}
function $0579e45100c644f0$var$_handleRequestDepositError2(error) {
    console.error(error);
    if (error.message.includes("Booking session timed out") || error.message.includes("Booking terms must be accepted")) {
        $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_handleBookingSessionError, $0579e45100c644f0$var$_handleBookingSessionError2).call(this, error.message);
        return;
    }
    let message;
    if (error.message.includes("maximum number of appointments booked") || error.message.includes("not currently accepting appointment bookings from you")) message = error.message;
    else if (error.message === "Payment cancelled.") message = "The payment was cancelled, please try again.";
    else if (error.message === "Login cancelled.") message = "Login cancelled. Please log in or register to book your appointment.";
    else if (error.message === "The server could not be reached.") message = "The server could not be reached. Please try again later.";
    else message = "There was a problem retrieving the deposit payment details. Please try again.";
    bootbox.alert({
        message: message,
        backdrop: true
    });
    $0579e45100c644f0$var$_classPrivateMethodGet(this, $0579e45100c644f0$var$_scrollToContent, $0579e45100c644f0$var$_scrollToContent2).call(this);
}
function $0579e45100c644f0$var$_handleBookingSessionError2(errMessage) {
    let displayMessage;
    if (errMessage.includes("Booking session timed out")) displayMessage = "Your appointment booking timed out. <br> Please try again.";
    else if (errMessage.includes("Booking terms must be accepted")) displayMessage = "You must accept the booking terms before you can book an appointment.";
    else displayMessage = errMessage;
    bootbox.alert({
        message: displayMessage,
        callback: ()=>{
            window.pageRouter.refreshPage();
        },
        backdrop: true
    });
}

});
parcelRequire.register("9b61C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $6ae9d0958fd84fe1$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $6ae9d0958fd84fe1$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $6ae9d0958fd84fe1$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $6ae9d0958fd84fe1$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $6ae9d0958fd84fe1$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $6ae9d0958fd84fe1$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $6ae9d0958fd84fe1$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $6ae9d0958fd84fe1$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $6ae9d0958fd84fe1$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $6ae9d0958fd84fe1$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $6ae9d0958fd84fe1$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $6ae9d0958fd84fe1$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $6ae9d0958fd84fe1$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $6ae9d0958fd84fe1$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $6ae9d0958fd84fe1$var$_ui = /*#__PURE__*/ new WeakMap();
var $6ae9d0958fd84fe1$var$_pagination = /*#__PURE__*/ new WeakMap();
var $6ae9d0958fd84fe1$var$_selectedDate = /*#__PURE__*/ new WeakMap();
var $6ae9d0958fd84fe1$var$_defaultDate = /*#__PURE__*/ new WeakMap();
var $6ae9d0958fd84fe1$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $6ae9d0958fd84fe1$var$_initDatePicker = /*#__PURE__*/ new WeakSet();
var $6ae9d0958fd84fe1$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $6ae9d0958fd84fe1$var$_updateDate = /*#__PURE__*/ new WeakSet();
var $6ae9d0958fd84fe1$var$_updatePagination = /*#__PURE__*/ new WeakSet();
var $6ae9d0958fd84fe1$var$_isFirstPage = /*#__PURE__*/ new WeakSet();
class $6ae9d0958fd84fe1$var$AppointmentList {
    get eventTarget() {
        return $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list;
    }
    constructor(){
        $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(this, $6ae9d0958fd84fe1$var$_isFirstPage);
        $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(this, $6ae9d0958fd84fe1$var$_updatePagination);
        $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(this, $6ae9d0958fd84fe1$var$_updateDate);
        $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(this, $6ae9d0958fd84fe1$var$_bindEvents);
        $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(this, $6ae9d0958fd84fe1$var$_initDatePicker);
        $6ae9d0958fd84fe1$var$_classPrivateMethodInitSpec(this, $6ae9d0958fd84fe1$var$_cacheUiElements);
        $6ae9d0958fd84fe1$var$_classPrivateFieldInitSpec(this, $6ae9d0958fd84fe1$var$_ui, {
            writable: true,
            value: void 0
        });
        $6ae9d0958fd84fe1$var$_classPrivateFieldInitSpec(this, $6ae9d0958fd84fe1$var$_pagination, {
            writable: true,
            value: void 0
        });
        $6ae9d0958fd84fe1$var$_classPrivateFieldInitSpec(this, $6ae9d0958fd84fe1$var$_selectedDate, {
            writable: true,
            value: void 0
        });
        $6ae9d0958fd84fe1$var$_classPrivateFieldInitSpec(this, $6ae9d0958fd84fe1$var$_defaultDate, {
            writable: true,
            value: void 0
        });
        $6ae9d0958fd84fe1$var$_classPrivateFieldSet(this, $6ae9d0958fd84fe1$var$_pagination, {
            history: [],
            currentStart: "",
            nextStart: ""
        });
    }
    init() {
        $6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_cacheUiElements, $6ae9d0958fd84fe1$var$_cacheUiElements2).call(this);
        $6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_initDatePicker, $6ae9d0958fd84fe1$var$_initDatePicker2).call(this);
        $6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_bindEvents, $6ae9d0958fd84fe1$var$_bindEvents2).call(this);
    }
    show(_ref) {
        let lastPage = _ref.lastPage, start = _ref.start, end = _ref.end, appointments = _ref.appointments;
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list.empty();
        if (appointments.length === 0) {
            const $row = $('<div class="appointment py-2">Sorry, there are no appointments available after the selected date.</div>');
            $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list.append($row);
        } else {
            $.each(appointments, (i, appointment)=>{
                const startTime = moment(appointment.start);
                const $row = $(`<div class="appointment row border-bottom py-2"><div class="col-sm-4 px-0">${startTime.format("ddd DD/MM/YYYY")}</div><div class="col-sm-3 px-0">${startTime.format("h:mm a")}</div><div class="col-sm-5 px-0">${appointment.provider.fullName}</div></div>`);
                $row.attr("data-id", appointment.id);
                $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list.append($row);
                $row.click(()=>{
                    const $allRows = $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list.find(".appointment");
                    $allRows.removeClass("active");
                    $row.addClass("active");
                    this.eventTarget.triggerHandler("select.appointment-list", appointment);
                });
            });
            $6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_updatePagination, $6ae9d0958fd84fe1$var$_updatePagination2).call(this, lastPage, start, end);
        }
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).wrap.removeClass("hidden");
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).wrap.fadeIn();
        window.scroller.scrollToElemTop($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).wrap);
    }
    previousPage() {
        const previousStart = $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).history.pop();
        this.eventTarget.triggerHandler("change.appointment-list", previousStart);
    }
    nextPage() {
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).history.push($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).currentStart);
        this.eventTarget.triggerHandler("change.appointment-list", $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).nextStart);
    }
    reset() {
        const currentDate = $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.datetimepicker("date");
        if (!currentDate.isSame($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_defaultDate))) // Update the date picker (the handler calls this.#updateDate)
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.datetimepicker("date", $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_defaultDate));
        else // We don't need to update the datepicker control.
        $6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_updateDate, $6ae9d0958fd84fe1$var$_updateDate2).call(this, $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_defaultDate));
    }
    clear() {
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).wrap.fadeOut();
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).backButton.fadeOut();
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).nextButton.fadeOut();
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list.empty();
        $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).history = [];
    }
    remove(appointmentId) {
        const $row = $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).list.find(`[data-id='${appointmentId}']`);
        $row.remove();
    }
}
module.exports.default = $6ae9d0958fd84fe1$var$AppointmentList;
function $6ae9d0958fd84fe1$var$_cacheUiElements2() {
    $6ae9d0958fd84fe1$var$_classPrivateFieldSet(this, $6ae9d0958fd84fe1$var$_ui, {
        datePicker: $("#earliest-date-picker"),
        wrap: $("#select-appointment-wrap"),
        list: $(".appointments"),
        backButton: $("#select-appointment-wrap .btn.back"),
        nextButton: $("#select-appointment-wrap .btn.next")
    });
}
function $6ae9d0958fd84fe1$var$_initDatePicker2() {
    $6ae9d0958fd84fe1$var$_classPrivateFieldSet(this, $6ae9d0958fd84fe1$var$_defaultDate, moment($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.data("default-date")));
    $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.datetimepicker({
        format: "DD/MM/YYYY",
        // This is the DISPLAY format
        defaultDate: $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_defaultDate),
        minDate: moment($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.data("min-date")),
        maxDate: moment($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.data("max-date"))
    });
    $6ae9d0958fd84fe1$var$_classPrivateFieldSet(this, $6ae9d0958fd84fe1$var$_selectedDate, $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.datetimepicker("viewDate"));
}
function $6ae9d0958fd84fe1$var$_bindEvents2() {
    $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).backButton.click(()=>{
        this.previousPage();
    });
    $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).nextButton.click(()=>{
        this.nextPage();
    });
    $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.on("change.datetimepicker", (e)=>{
        // Update the appointment list
        $6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_updateDate, $6ae9d0958fd84fe1$var$_updateDate2).call(this, e.date);
    });
}
function $6ae9d0958fd84fe1$var$_updateDate2(newDate) {
    this.clear();
    $6ae9d0958fd84fe1$var$_classPrivateFieldSet(this, $6ae9d0958fd84fe1$var$_selectedDate, newDate);
    this.eventTarget.triggerHandler("change.appointment-list", $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_selectedDate));
}
function $6ae9d0958fd84fe1$var$_updatePagination2(lastPage, start, end) {
    $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).currentStart = moment(start).toDate();
    // Next page begins after this page's last appointment
    $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).nextStart = moment(end).toDate();
    if ($6ae9d0958fd84fe1$var$_classPrivateMethodGet(this, $6ae9d0958fd84fe1$var$_isFirstPage, $6ae9d0958fd84fe1$var$_isFirstPage2).call(this)) $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).backButton.fadeOut();
    else $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).backButton.fadeIn();
    if (lastPage) $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).nextButton.fadeOut();
    else $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).nextButton.fadeIn();
}
function $6ae9d0958fd84fe1$var$_isFirstPage2() {
    const min = moment($6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_ui).datePicker.datetimepicker("viewDate"), "DD-MM-YYYY");
    return $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_selectedDate).isSame(min, "day") && $6ae9d0958fd84fe1$var$_classPrivateFieldGet(this, $6ae9d0958fd84fe1$var$_pagination).history.length === 0;
}

});

parcelRequire.register("ayFEK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7afd6470d54d01d0$var$_currency = $7afd6470d54d01d0$var$_interopRequireDefault((parcelRequire("gay5R")));

var $7afd6470d54d01d0$var$_money = $7afd6470d54d01d0$var$_interopRequireDefault((parcelRequire("hTKpX")));
function $7afd6470d54d01d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $7afd6470d54d01d0$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $7afd6470d54d01d0$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $7afd6470d54d01d0$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $7afd6470d54d01d0$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $7afd6470d54d01d0$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $7afd6470d54d01d0$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $7afd6470d54d01d0$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $7afd6470d54d01d0$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $7afd6470d54d01d0$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $7afd6470d54d01d0$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $7afd6470d54d01d0$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $7afd6470d54d01d0$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $7afd6470d54d01d0$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $7afd6470d54d01d0$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $7afd6470d54d01d0$var$_ui = /*#__PURE__*/ new WeakMap();
var $7afd6470d54d01d0$var$_details = /*#__PURE__*/ new WeakMap();
var $7afd6470d54d01d0$var$_updateUi = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_showPhotograph = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_hidePhotograph = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_showPrice = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_hidePrice = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_showDeposit = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_hideDeposit = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_clearUi = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $7afd6470d54d01d0$var$_bindEvents = /*#__PURE__*/ new WeakSet();
class $7afd6470d54d01d0$var$AppointmentCard {
    constructor(){
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_bindEvents);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_cacheUiElements);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_clearUi);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_hideDeposit);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_showDeposit);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_hidePrice);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_showPrice);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_hidePhotograph);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_showPhotograph);
        $7afd6470d54d01d0$var$_classPrivateMethodInitSpec(this, $7afd6470d54d01d0$var$_updateUi);
        $7afd6470d54d01d0$var$_classPrivateFieldInitSpec(this, $7afd6470d54d01d0$var$_ui, {
            writable: true,
            value: void 0
        });
        $7afd6470d54d01d0$var$_classPrivateFieldInitSpec(this, $7afd6470d54d01d0$var$_details, {
            writable: true,
            value: void 0
        });
    }
    get eventTarget() {
        return $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.card;
    }
    init() {
        $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_cacheUiElements, $7afd6470d54d01d0$var$_cacheUiElements2).call(this);
        $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_bindEvents, $7afd6470d54d01d0$var$_bindEvents2).call(this);
    }
    select(appointment) {
        $7afd6470d54d01d0$var$_classPrivateFieldSet(this, $7afd6470d54d01d0$var$_details, {
            id: appointment.id,
            deposit: appointment.treatment.deposit.value,
            note: ""
        });
        $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_updateUi, $7afd6470d54d01d0$var$_updateUi2).call(this, appointment);
    }
    deselect() {
        $7afd6470d54d01d0$var$_classPrivateFieldSet(this, $7afd6470d54d01d0$var$_details, {
            id: -1,
            deposit: 0,
            note: ""
        });
        $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_clearUi, $7afd6470d54d01d0$var$_clearUi2).call(this);
    }
}
module.exports.default = $7afd6470d54d01d0$var$AppointmentCard;
function $7afd6470d54d01d0$var$_updateUi2(_ref) {
    let start = _ref.start, provider = _ref.provider, treatment = _ref.treatment;
    const date = moment(start).format("ddd DD/MM/YYYY");
    const time = `${moment(start).format("h:mm a")}`;
    if (treatment.price.value > 0) $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_showPrice, $7afd6470d54d01d0$var$_showPrice2).call(this, treatment);
    else $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_hidePrice, $7afd6470d54d01d0$var$_hidePrice2).call(this);
    if (treatment.deposit.value > 0) $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_showDeposit, $7afd6470d54d01d0$var$_showDeposit2).call(this, treatment);
    else $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_hideDeposit, $7afd6470d54d01d0$var$_hideDeposit2).call(this);
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.date.text(date);
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.time.text(time);
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.provider.text(provider.fullName);
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.type.text(treatment.description);
    if (provider.photographUrl) $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_showPhotograph, $7afd6470d54d01d0$var$_showPhotograph2).call(this, provider.photographUrl);
    else $7afd6470d54d01d0$var$_classPrivateMethodGet(this, $7afd6470d54d01d0$var$_hidePhotograph, $7afd6470d54d01d0$var$_hidePhotograph2).call(this);
    // Display the appointment card and scroll to it (if not disabled)
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.card.removeClass("hidden");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).notSelected.card.addClass("hidden");
    window.scroller.scrollToElemTop($7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.card);
}
function $7afd6470d54d01d0$var$_showPhotograph2(url) {
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.providerImg.attr("src", url);
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.imgContainer.removeClass("hidden");
}
function $7afd6470d54d01d0$var$_hidePhotograph2() {
    // An empty data url is used for the src when there is no image to show
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.providerImg.attr("src", "data:,");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.imgContainer.addClass("hidden");
}
function $7afd6470d54d01d0$var$_showPrice2(treatment) {
    const currency = new $7afd6470d54d01d0$var$_currency.default(treatment.price.currencySymbol, treatment.price.currencyCode);
    const price = new $7afd6470d54d01d0$var$_money.default(currency);
    price.value = treatment.price.originalValue;
    const newPrice = new $7afd6470d54d01d0$var$_money.default(currency);
    newPrice.value = treatment.price.value;
    // If the new price is greater or equal to the original price the display it as the standard price
    if (newPrice.value >= price.value) $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.price.text(newPrice.getDisplayString());
    else {
        // Otherwise display the price as a discount to the original price
        const cleanPrice = DOMPurify.sanitize(price.getDisplayString());
        const cleanDiscount = DOMPurify.sanitize(newPrice.getDisplayString());
        let $discount = $(`<span>${cleanDiscount}&nbsp;<span class="old-price">Was:&nbsp<span class="text-decoration-line-through">${cleanPrice}</span></span>`);
        $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.price.html($discount);
    }
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.priceContainer.removeClass("hidden");
}
function $7afd6470d54d01d0$var$_hidePrice2() {
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.price.text("-");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.priceContainer.addClass("hidden");
    // Can't calculate outstanding amount if no price given
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.outstanding.text("-");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.outstandingContainer.addClass("hidden");
}
function $7afd6470d54d01d0$var$_showDeposit2(treatment) {
    const currency = new $7afd6470d54d01d0$var$_currency.default(treatment.deposit.currencySymbol, treatment.deposit.currencyCode);
    const deposit = new $7afd6470d54d01d0$var$_money.default(currency);
    deposit.value = treatment.deposit.value;
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.deposit.text(deposit.getDisplayString());
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.depositContainer.removeClass("hidden");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.noDepositContainer.addClass("hidden");
    // Show outstanding amount if the full price is given
    // and it can be calculated
    if (treatment.price.value > 0) {
        const outstanding = new $7afd6470d54d01d0$var$_money.default(currency);
        outstanding.value = treatment.price.value - deposit.value;
        $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.outstanding.text(outstanding.getDisplayString());
        $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.outstandingContainer.removeClass("hidden");
    }
}
function $7afd6470d54d01d0$var$_hideDeposit2() {
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.deposit.text("-");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.outstanding.text("-");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.depositContainer.addClass("hidden");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.noDepositContainer.removeClass("hidden");
}
function $7afd6470d54d01d0$var$_clearUi2() {
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.date.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.time.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.provider.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.type.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.price.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.deposit.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.outstanding.text("");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.note.text("");
    // Hide the appointment card
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.card.addClass("hidden");
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).notSelected.card.removeClass("hidden");
}
function $7afd6470d54d01d0$var$_cacheUiElements2() {
    $7afd6470d54d01d0$var$_classPrivateFieldSet(this, $7afd6470d54d01d0$var$_ui, {
        notSelected: {
            card: $("#appointment-not-selected.card")
        },
        selected: {
            card: $("#appointment-selected.card"),
            date: $(".appointment-date"),
            time: $(".appointment-time"),
            provider: $(".appointment-provider"),
            providerImg: $("#appointment-selected img"),
            imgContainer: $("#appointment-selected .img-container"),
            type: $(".appointment-type"),
            priceContainer: $(".price-container"),
            price: $(".appointment-price"),
            depositContainer: $(".deposit-container"),
            deposit: $(".appointment-deposit"),
            outstandingContainer: $(".outstanding-container"),
            outstanding: $(".appointment-outstanding"),
            noDepositContainer: $(".no-deposit-container"),
            note: $(".appointment-note"),
            confirmButton: $("#btn-confirm-appointment")
        }
    });
}
function $7afd6470d54d01d0$var$_bindEvents2() {
    $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.confirmButton.click(()=>{
        $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_details).note = $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_ui).selected.note.val();
        this.eventTarget.triggerHandler("confirm.appointment-card", $7afd6470d54d01d0$var$_classPrivateFieldGet(this, $7afd6470d54d01d0$var$_details));
    });
}

});
parcelRequire.register("gay5R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $bc5806c139cc9752$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $bc5806c139cc9752$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $bc5806c139cc9752$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $bc5806c139cc9752$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $bc5806c139cc9752$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $bc5806c139cc9752$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $bc5806c139cc9752$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $bc5806c139cc9752$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $bc5806c139cc9752$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $bc5806c139cc9752$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $bc5806c139cc9752$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $bc5806c139cc9752$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $bc5806c139cc9752$var$_symbol = /*#__PURE__*/ new WeakMap();
var $bc5806c139cc9752$var$_isoCode = /*#__PURE__*/ new WeakMap();
class $bc5806c139cc9752$var$Currency {
    get symbol() {
        return $bc5806c139cc9752$var$_classPrivateFieldGet(this, $bc5806c139cc9752$var$_symbol);
    }
    get isoCode() {
        return $bc5806c139cc9752$var$_classPrivateFieldGet(this, $bc5806c139cc9752$var$_isoCode);
    }
    get hasSymbol() {
        return $bc5806c139cc9752$var$_classPrivateFieldGet(this, $bc5806c139cc9752$var$_symbol) !== "";
    }
    constructor(){
        let symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        let isoCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        $bc5806c139cc9752$var$_classPrivateFieldInitSpec(this, $bc5806c139cc9752$var$_symbol, {
            writable: true,
            value: void 0
        });
        $bc5806c139cc9752$var$_classPrivateFieldInitSpec(this, $bc5806c139cc9752$var$_isoCode, {
            writable: true,
            value: void 0
        });
        $bc5806c139cc9752$var$_classPrivateFieldSet(this, $bc5806c139cc9752$var$_symbol, symbol);
        $bc5806c139cc9752$var$_classPrivateFieldSet(this, $bc5806c139cc9752$var$_isoCode, isoCode);
    }
}
module.exports.default = $bc5806c139cc9752$var$Currency;

});

parcelRequire.register("hTKpX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $d07b94542d1202ae$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $d07b94542d1202ae$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $d07b94542d1202ae$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $d07b94542d1202ae$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $d07b94542d1202ae$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $d07b94542d1202ae$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $d07b94542d1202ae$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $d07b94542d1202ae$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $d07b94542d1202ae$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $d07b94542d1202ae$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $d07b94542d1202ae$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $d07b94542d1202ae$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $d07b94542d1202ae$var$_value = /*#__PURE__*/ new WeakMap();
var $d07b94542d1202ae$var$_currency = /*#__PURE__*/ new WeakMap();
class $d07b94542d1202ae$var$Money {
    get value() {
        return $d07b94542d1202ae$var$_classPrivateFieldGet(this, $d07b94542d1202ae$var$_value);
    }
    set value(val) {
        $d07b94542d1202ae$var$_classPrivateFieldSet(this, $d07b94542d1202ae$var$_value, val);
    }
    get currency() {
        return $d07b94542d1202ae$var$_classPrivateFieldGet(this, $d07b94542d1202ae$var$_currency);
    }
    constructor(currency){
        $d07b94542d1202ae$var$_classPrivateFieldInitSpec(this, $d07b94542d1202ae$var$_value, {
            writable: true,
            value: void 0
        });
        $d07b94542d1202ae$var$_classPrivateFieldInitSpec(this, $d07b94542d1202ae$var$_currency, {
            writable: true,
            value: void 0
        });
        $d07b94542d1202ae$var$_classPrivateFieldSet(this, $d07b94542d1202ae$var$_currency, currency);
    }
    getDisplayString() {
        const displayString = $d07b94542d1202ae$var$_classPrivateFieldGet(this, $d07b94542d1202ae$var$_value).toLocaleString("en-GB", {
            style: "currency",
            currency: $d07b94542d1202ae$var$_classPrivateFieldGet(this, $d07b94542d1202ae$var$_currency).isoCode
        });
        // Remove trailing zeroes if a round number
        return displayString.replace(".00", "");
    }
}
module.exports.default = $d07b94542d1202ae$var$Money;

});


parcelRequire.register("bPqot", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89c8ee601fcde980$var$_requestService = $89c8ee601fcde980$var$_interopRequireDefault((parcelRequire("30IfK")));
function $89c8ee601fcde980$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $89c8ee601fcde980$var$AppointmentsService {
    static async getNavbar() {
        let returnUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
        const url = "/Home/Navbar";
        return $89c8ee601fcde980$var$_requestService.default.get(url, {
            ReturnUrl: returnUrl
        });
    }
    static async getNavbarNav() {
        let returnUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
        const url = "/Home/NavbarNav";
        return $89c8ee601fcde980$var$_requestService.default.get(url, {
            ReturnUrl: returnUrl
        });
    }
    static async getTerms() {
        const url = "/Book/Terms";
        return $89c8ee601fcde980$var$_requestService.default.get(url);
    }
    static async getAppointments(provider, treatment, start) {
        let queryString = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
        let url = "/Book/GetAppointments";
        if (queryString !== "") url += `?${queryString}`;
        let startDate = start || new Date();
        startDate = startDate.toISOString();
        return $89c8ee601fcde980$var$_requestService.default.get(url, {
            provider: provider,
            treatmentId: treatment,
            start: startDate
        });
    }
    static setCsrfToken(csrfToken) {
        $89c8ee601fcde980$var$_requestService.default.setCsrfTokenIfEmpty(csrfToken);
    }
    static async acceptBookingTerms(appointmentId) {
        const url = "/Book/AcceptTerms";
        return $89c8ee601fcde980$var$_requestService.default.post(url, {
            appointmentId: appointmentId
        });
    }
    static async beginBooking(appointmentId, bookingNote) {
        const url = "/Book/BeginBooking";
        return $89c8ee601fcde980$var$_requestService.default.post(url, {
            appointmentId: appointmentId,
            bookingNote: bookingNote
        });
    }
    static async getPaymentDetails() {
        const url = "/Book/GetPaymentDetails";
        return $89c8ee601fcde980$var$_requestService.default.get(url);
    }
    static async confirmAppointment() {
        const url = "/Book/ConfirmAppointment";
        return $89c8ee601fcde980$var$_requestService.default.post(url);
    }
    static async sendAppointmentConfirmationEmail(appointmentId) {
        const url = "/Home/SendAppointmentEmail";
        return $89c8ee601fcde980$var$_requestService.default.post(url, {
            appointmentId: appointmentId
        });
    }
}
module.exports.default = $89c8ee601fcde980$var$AppointmentsService;

});
parcelRequire.register("30IfK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hxV1y = parcelRequire("hxV1y");
function $2313b2eb5477027a$var$_classStaticPrivateMethodGet(receiver, classConstructor, method) {
    $2313b2eb5477027a$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
    return method;
}
function $2313b2eb5477027a$var$_classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) {
    $2313b2eb5477027a$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
    $2313b2eb5477027a$var$_classCheckPrivateStaticFieldDescriptor(descriptor, "set");
    $2313b2eb5477027a$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $2313b2eb5477027a$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
    $2313b2eb5477027a$var$_classCheckPrivateStaticAccess(receiver, classConstructor);
    $2313b2eb5477027a$var$_classCheckPrivateStaticFieldDescriptor(descriptor, "get");
    return $2313b2eb5477027a$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $2313b2eb5477027a$var$_classCheckPrivateStaticFieldDescriptor(descriptor, action) {
    if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}
function $2313b2eb5477027a$var$_classCheckPrivateStaticAccess(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}
function $2313b2eb5477027a$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
const $2313b2eb5477027a$var$sessionIdHeaderName = "S4D-Session-ID";
const $2313b2eb5477027a$var$authIdHeaderName = "S4D-Auth-ID";
const $2313b2eb5477027a$var$csrfIdHeaderName = "S4D-CSRF-ID";
const $2313b2eb5477027a$var$routerNavigationHeaderName = "S4D-Navigation";
class $2313b2eb5477027a$var$RequestService {
    /**
   * if the CSRF Token is not known by the request service,
   * sets the CSRF Token to the given value.
   * Returns true if the value was set, otherwise returns false.
   */ static setCsrfTokenIfEmpty(csrfToken) {
        // Ignore if csrf token is already known
        if ($2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_csrfId)) return false;
        $2313b2eb5477027a$var$_classStaticPrivateFieldSpecSet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_csrfId, csrfToken);
        return true;
    }
    static navigate(url, data, additionalHeaders) {
        return $2313b2eb5477027a$var$_classStaticPrivateMethodGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_ajax).call($2313b2eb5477027a$var$RequestService, "GET", url, data, additionalHeaders, true);
    }
    static get(url, data, additionalHeaders) {
        return $2313b2eb5477027a$var$_classStaticPrivateMethodGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_ajax).call($2313b2eb5477027a$var$RequestService, "GET", url, data, additionalHeaders, false);
    }
    static post(url, data, additionalHeaders) {
        return $2313b2eb5477027a$var$_classStaticPrivateMethodGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_ajax).call($2313b2eb5477027a$var$RequestService, "POST", url, data, additionalHeaders, false);
    }
}
module.exports.default = $2313b2eb5477027a$var$RequestService;
function $2313b2eb5477027a$var$_ajax(method, url, additionalData, additionalHeaders) {
    let navigation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let data = $2313b2eb5477027a$var$_classStaticPrivateMethodGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_getDefaultData).call(this);
    data = {
        ...data,
        ...additionalData
    };
    let headers = $2313b2eb5477027a$var$_classStaticPrivateMethodGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_getRequestHeaders).call(this);
    headers = {
        ...headers,
        ...additionalHeaders
    };
    // If this is a navigation request (as opposed to an API request)
    // append the navigation header
    if (navigation) headers[$2313b2eb5477027a$var$routerNavigationHeaderName] = "RouterNavigation";
    return new Promise((resolve, reject)=>{
        $.ajax({
            method: method,
            url: url,
            data: data,
            headers: headers
        }).done((content, status, jqXHR)=>{
            $2313b2eb5477027a$var$_classStaticPrivateMethodGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_processResponseHeaders).call(this, jqXHR);
            // Reject non-success responses
            if (jqXHR.status !== 200) {
                const errResp = $2313b2eb5477027a$var$_classStaticPrivateMethodGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_createErrorResponse).call(this, jqXHR);
                reject(errResp);
                return;
            }
            // Success
            resolve(content);
        }).fail((jqXHR)=>{
            $2313b2eb5477027a$var$_classStaticPrivateMethodGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_processResponseHeaders).call(this, jqXHR);
            const errResp = $2313b2eb5477027a$var$_classStaticPrivateMethodGet(this, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_createErrorResponse).call(this, jqXHR);
            reject(errResp);
        });
    });
}
function $2313b2eb5477027a$var$_createErrorResponse(jqXHR) {
    return {
        status: jqXHR.status,
        statusText: jqXHR.statusText,
        responseText: jqXHR.responseText,
        responseJSON: jqXHR.responseJSON,
        contentType: jqXHR.getResponseHeader("Content-Type")
    };
}
function $2313b2eb5477027a$var$_processResponseHeaders(jqXHR) {
    // Replace ids if provided in the response headers
    $2313b2eb5477027a$var$_classStaticPrivateFieldSpecSet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_sessionId, jqXHR.getResponseHeader($2313b2eb5477027a$var$sessionIdHeaderName) ?? $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_sessionId));
    $2313b2eb5477027a$var$_classStaticPrivateFieldSpecSet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_authId, jqXHR.getResponseHeader($2313b2eb5477027a$var$authIdHeaderName) ?? $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_authId));
    $2313b2eb5477027a$var$_classStaticPrivateFieldSpecSet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_csrfId, jqXHR.getResponseHeader($2313b2eb5477027a$var$csrfIdHeaderName) ?? $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_csrfId));
    // AJAX redirects are handled manually, so they receive a 200 "OK" status
    // and the location is given in the response headers.
    // Convert these responses back to 302 redirect responses internally 
    // so they can be distinguished in request error handlers.
    const location = jqXHR.getResponseHeader("location");
    if (location) {
        if (jqXHR.status === 200) {
            jqXHR.status = 302;
            jqXHR.statusText = "Found";
        }
        // Include the location in any case
        jqXHR.responseJSON = {
            location: location
        };
    }
}
function $2313b2eb5477027a$var$_getDefaultData() {
    return {
        r: $hxV1y.RouterRequestType.Standard
    };
}
function $2313b2eb5477027a$var$_getRequestHeaders() {
    const headers = {};
    if ($2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_sessionId)) headers[$2313b2eb5477027a$var$sessionIdHeaderName] = $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_sessionId);
    if ($2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_authId)) headers[$2313b2eb5477027a$var$authIdHeaderName] = $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_authId);
    if ($2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_csrfId)) headers[$2313b2eb5477027a$var$csrfIdHeaderName] = $2313b2eb5477027a$var$_classStaticPrivateFieldSpecGet($2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$RequestService, $2313b2eb5477027a$var$_csrfId);
    return headers;
}
var $2313b2eb5477027a$var$_sessionId = {
    writable: true,
    value: ""
};
var $2313b2eb5477027a$var$_authId = {
    writable: true,
    value: ""
};
var $2313b2eb5477027a$var$_csrfId = {
    writable: true,
    value: ""
};

});
parcelRequire.register("hxV1y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RouterRequestType = void 0;
const $cc61c08810384685$var$RouterRequestType = Object.freeze({
    NotRouterRequest: 0,
    Standard: 1,
    Modal: 2
});
module.exports.RouterRequestType = $cc61c08810384685$var$RouterRequestType;

});



parcelRequire.register("gdohi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bce0b150229dfd08$var$_utils = $bce0b150229dfd08$var$_interopRequireDefault((parcelRequire("6L3JM")));

var $bce0b150229dfd08$var$_router2 = $bce0b150229dfd08$var$_interopRequireDefault((parcelRequire("4Z8W0")));

var $bce0b150229dfd08$var$_modal = $bce0b150229dfd08$var$_interopRequireDefault((parcelRequire("gOADx")));
function $bce0b150229dfd08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bce0b150229dfd08$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $bce0b150229dfd08$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $bce0b150229dfd08$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $bce0b150229dfd08$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $bce0b150229dfd08$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $bce0b150229dfd08$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $bce0b150229dfd08$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $bce0b150229dfd08$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $bce0b150229dfd08$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $bce0b150229dfd08$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $bce0b150229dfd08$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $bce0b150229dfd08$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $bce0b150229dfd08$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $bce0b150229dfd08$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $bce0b150229dfd08$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $bce0b150229dfd08$var$_router = /*#__PURE__*/ new WeakMap();
var $bce0b150229dfd08$var$_title = /*#__PURE__*/ new WeakMap();
var $bce0b150229dfd08$var$_$container = /*#__PURE__*/ new WeakMap();
var $bce0b150229dfd08$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $bce0b150229dfd08$var$_refreshIntercepts = /*#__PURE__*/ new WeakSet();
var $bce0b150229dfd08$var$_interceptSubmit = /*#__PURE__*/ new WeakSet();
var $bce0b150229dfd08$var$_awaitLoginSuccess = /*#__PURE__*/ new WeakSet();
var $bce0b150229dfd08$var$_getContent = /*#__PURE__*/ new WeakSet();
class $bce0b150229dfd08$var$LoginModal extends $bce0b150229dfd08$var$_modal.default {
    constructor(){
        super();
        $bce0b150229dfd08$var$_classPrivateMethodInitSpec(this, $bce0b150229dfd08$var$_getContent);
        $bce0b150229dfd08$var$_classPrivateMethodInitSpec(this, $bce0b150229dfd08$var$_awaitLoginSuccess);
        $bce0b150229dfd08$var$_classPrivateMethodInitSpec(this, $bce0b150229dfd08$var$_interceptSubmit);
        $bce0b150229dfd08$var$_classPrivateMethodInitSpec(this, $bce0b150229dfd08$var$_refreshIntercepts);
        $bce0b150229dfd08$var$_classPrivateMethodInitSpec(this, $bce0b150229dfd08$var$_bindEvents);
        $bce0b150229dfd08$var$_classPrivateFieldInitSpec(this, $bce0b150229dfd08$var$_router, {
            writable: true,
            value: void 0
        });
        $bce0b150229dfd08$var$_classPrivateFieldInitSpec(this, $bce0b150229dfd08$var$_title, {
            writable: true,
            value: void 0
        });
        $bce0b150229dfd08$var$_classPrivateFieldInitSpec(this, $bce0b150229dfd08$var$_$container, {
            writable: true,
            value: void 0
        });
        $bce0b150229dfd08$var$_classPrivateFieldSet(this, $bce0b150229dfd08$var$_router, new $bce0b150229dfd08$var$_router2.default());
        $bce0b150229dfd08$var$_classPrivateFieldSet(this, $bce0b150229dfd08$var$_title, "Please login or register");
    }
    init() {
        $bce0b150229dfd08$var$_classPrivateFieldSet(this, $bce0b150229dfd08$var$_$container, $("#booking-modal #content-wrap"));
        this.setContent($bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_title), $bce0b150229dfd08$var$_classPrivateMethodGet(this, $bce0b150229dfd08$var$_getContent, $bce0b150229dfd08$var$_getContent2).call(this));
        $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_router).init($bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_$container), true);
        $bce0b150229dfd08$var$_classPrivateMethodGet(this, $bce0b150229dfd08$var$_bindEvents, $bce0b150229dfd08$var$_bindEvents2).call(this);
    }
    async open() {
        await super.open();
        await $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_router).load("/Account/Login", {
            ReturnUrl: "/Account/LoginSuccess"
        });
    }
    async requestLogin() {
        await this.open();
        try {
            await $bce0b150229dfd08$var$_classPrivateMethodGet(this, $bce0b150229dfd08$var$_awaitLoginSuccess, $bce0b150229dfd08$var$_awaitLoginSuccess2).call(this);
        } catch (error) {
            if (error.message === "Aborted") error.message = "Login cancelled.";
            throw error;
        } finally{
            await this.close();
        }
    // Login success
    }
}
module.exports.default = $bce0b150229dfd08$var$LoginModal;
function $bce0b150229dfd08$var$_bindEvents2() {
    $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_$container).on("content-loaded", async (e, _ref)=>{
        let url = _ref.url;
        // Ignore propagated routing events, we only care about 
        // full navigation events directly triggered on our container.
        if (e.target != $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_$container)[0]) return;
        // Consume the event so if there is more than one router
        // (e.g., another modal) they don't both fire.
        e.stopPropagation();
        this.scrollToContent();
        $bce0b150229dfd08$var$_classPrivateMethodGet(this, $bce0b150229dfd08$var$_refreshIntercepts, $bce0b150229dfd08$var$_refreshIntercepts2).call(this);
    });
}
function $bce0b150229dfd08$var$_refreshIntercepts2() {
    $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_router).refreshIntercepts();
    $bce0b150229dfd08$var$_classPrivateMethodGet(this, $bce0b150229dfd08$var$_interceptSubmit, $bce0b150229dfd08$var$_interceptSubmit2).call(this);
}
function $bce0b150229dfd08$var$_interceptSubmit2() {
    let $forms = $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_$container).find("form");
    $forms.off("submit").on("submit", async (e)=>{
        e.preventDefault();
        const $form = $(e.currentTarget);
        await $bce0b150229dfd08$var$_classPrivateFieldGet(this, $bce0b150229dfd08$var$_router).load($form.attr("action"), $form.serializeObject(), "POST");
    });
}
async function $bce0b150229dfd08$var$_awaitLoginSuccess2() {
    return $bce0b150229dfd08$var$_utils.default.promisifyEvent(document, "login-success", this.abortController.signal);
}
function $bce0b150229dfd08$var$_getContent2() {
    return $(`<div class="spinner d-flex justify-content-center mt-5 mb-5">
                <div class="page-spinner spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div id="content" class="row p-3"></div>`);
}

});
parcelRequire.register("6L3JM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $4eba080dfc24765b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $4eba080dfc24765b$var$Utils {
    /**
   * Wraps a jQuery event binding in a promise that resolves when the event is triggered.
   * Maybe be optionally aborted by passing and using an AbortSignal.
   */ static promisifyEvent(elem, event) {
        let abortSignal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        const $elem = elem instanceof jQuery ? elem : $(elem);
        if (abortSignal && abortSignal.aborted) return Promise.reject(new Error("Aborted"));
        return new Promise((resolve, reject)=>{
            if (abortSignal) abortSignal.addEventListener("abort", ()=>{
                reject(new Error("Aborted"));
            });
            const handler = (e, data)=>{
                resolve(data);
            };
            // Force a single binding by unbinding first
            $elem.off(event, handler).on(event, handler);
        });
    }
    /**
   * Races the given promise against a timeout of the specified milliseconds.
   * If the promise takes longer to resolve, then it times out and the promise is rejected.
   * @param {Promise} promise
   * @param {Number} ms
   * @returns A promise which resolves with the result of the given promise,
   *          or rejects if the time out is reached.
   */ static timeout(promise, ms) {
        let timer;
        return Promise.race([
            promise,
            // eslint-disable-next-line no-promise-executor-return
            new Promise((_, reject)=>setTimeout(reject, ms, `Timed out after ${ms} ms.`))
        ]).finally(()=>clearTimeout(timer));
    }
    /**
   * Returns a copy of the string with the first letter of each word capitalised.
   * @param {string} str the string to convert
   * @returns the converted string
   */ static randomId() {
        return Math.random().toString(36).substring(2);
    }
    static newURL(url) {
        if (typeof url === "string" || url instanceof String) return new URL(url, window.location.origin);
        else if (url instanceof URL) // Clone the url to ensure the original isn't affected
        return new URL(url, url.href);
        throw new Error("`url` must be a valid url string or URL object");
    }
}
module.exports.default = $4eba080dfc24765b$var$Utils;
$4eba080dfc24765b$var$_defineProperty($4eba080dfc24765b$var$Utils, "titleCase", function(str) {
    return str.replace(/(^|\s)\S/g, function(t) {
        return t.toUpperCase();
    });
});

});

parcelRequire.register("4Z8W0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a13ca2bf9a4b872$var$_linkInterceptor2 = $3a13ca2bf9a4b872$var$_interopRequireDefault((parcelRequire("hz37k")));

var $3a13ca2bf9a4b872$var$_linkInterceptCallback = $3a13ca2bf9a4b872$var$_interopRequireDefault((parcelRequire("2GAMm")));

var $3a13ca2bf9a4b872$var$_embeddedContentView = $3a13ca2bf9a4b872$var$_interopRequireDefault((parcelRequire("e7jpF")));
function $3a13ca2bf9a4b872$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3a13ca2bf9a4b872$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $3a13ca2bf9a4b872$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $3a13ca2bf9a4b872$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a13ca2bf9a4b872$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $3a13ca2bf9a4b872$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $3a13ca2bf9a4b872$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $3a13ca2bf9a4b872$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $3a13ca2bf9a4b872$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $3a13ca2bf9a4b872$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $3a13ca2bf9a4b872$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $3a13ca2bf9a4b872$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $3a13ca2bf9a4b872$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $3a13ca2bf9a4b872$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $3a13ca2bf9a4b872$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $3a13ca2bf9a4b872$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $3a13ca2bf9a4b872$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $3a13ca2bf9a4b872$var$_linkInterceptor = /*#__PURE__*/ new WeakMap();
var $3a13ca2bf9a4b872$var$_linkInterceptCb = /*#__PURE__*/ new WeakMap();
var $3a13ca2bf9a4b872$var$_contentView = /*#__PURE__*/ new WeakMap();
var $3a13ca2bf9a4b872$var$_ui = /*#__PURE__*/ new WeakMap();
var $3a13ca2bf9a4b872$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $3a13ca2bf9a4b872$var$_interceptInternalLinks = /*#__PURE__*/ new WeakSet();
var $3a13ca2bf9a4b872$var$_interceptLinks = /*#__PURE__*/ new WeakSet();
var $3a13ca2bf9a4b872$var$_enableLinkCallbacks = /*#__PURE__*/ new WeakSet();
var $3a13ca2bf9a4b872$var$_disableLinkCallbacks = /*#__PURE__*/ new WeakSet();
class $3a13ca2bf9a4b872$var$Router {
    // the current page
    constructor(){
        $3a13ca2bf9a4b872$var$_classPrivateMethodInitSpec(this, $3a13ca2bf9a4b872$var$_disableLinkCallbacks);
        $3a13ca2bf9a4b872$var$_classPrivateMethodInitSpec(this, $3a13ca2bf9a4b872$var$_enableLinkCallbacks);
        $3a13ca2bf9a4b872$var$_classPrivateMethodInitSpec(this, $3a13ca2bf9a4b872$var$_interceptLinks);
        $3a13ca2bf9a4b872$var$_classPrivateMethodInitSpec(this, $3a13ca2bf9a4b872$var$_interceptInternalLinks);
        $3a13ca2bf9a4b872$var$_classPrivateMethodInitSpec(this, $3a13ca2bf9a4b872$var$_cacheUiElements);
        $3a13ca2bf9a4b872$var$_classPrivateFieldInitSpec(this, $3a13ca2bf9a4b872$var$_linkInterceptor, {
            writable: true,
            value: void 0
        });
        $3a13ca2bf9a4b872$var$_classPrivateFieldInitSpec(this, $3a13ca2bf9a4b872$var$_linkInterceptCb, {
            writable: true,
            value: void 0
        });
        $3a13ca2bf9a4b872$var$_classPrivateFieldInitSpec(this, $3a13ca2bf9a4b872$var$_contentView, {
            writable: true,
            value: void 0
        });
        $3a13ca2bf9a4b872$var$_classPrivateFieldInitSpec(this, $3a13ca2bf9a4b872$var$_ui, {
            writable: true,
            value: void 0
        });
        $3a13ca2bf9a4b872$var$_defineProperty(this, "page", void 0);
        $3a13ca2bf9a4b872$var$_classPrivateFieldSet(this, $3a13ca2bf9a4b872$var$_linkInterceptor, new $3a13ca2bf9a4b872$var$_linkInterceptor2.default());
        $3a13ca2bf9a4b872$var$_classPrivateFieldSet(this, $3a13ca2bf9a4b872$var$_linkInterceptCb, new $3a13ca2bf9a4b872$var$_linkInterceptCallback.default($3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_linkInterceptor)));
        $3a13ca2bf9a4b872$var$_classPrivateFieldSet(this, $3a13ca2bf9a4b872$var$_contentView, new $3a13ca2bf9a4b872$var$_embeddedContentView.default());
    }
    init($container) {
        let isModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_contentView).init($container, isModal);
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_cacheUiElements, $3a13ca2bf9a4b872$var$_cacheUiElements2).call(this, $container);
        $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_linkInterceptor).init();
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_interceptInternalLinks, $3a13ca2bf9a4b872$var$_interceptInternalLinks2).call(this);
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_enableLinkCallbacks, $3a13ca2bf9a4b872$var$_enableLinkCallbacks2).call(this);
    }
    async load(url) {
        let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let http_method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
        await $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_contentView).load(url, data, http_method);
    }
    pauseLinkInterceptor() {
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_disableLinkCallbacks, $3a13ca2bf9a4b872$var$_disableLinkCallbacks2).call(this);
    }
    resumeLinkInterceptor() {
        this.refreshIntercepts();
    }
    refreshIntercepts() {
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_disableLinkCallbacks, $3a13ca2bf9a4b872$var$_disableLinkCallbacks2).call(this);
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_interceptInternalLinks, $3a13ca2bf9a4b872$var$_interceptInternalLinks2).call(this);
        $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_enableLinkCallbacks, $3a13ca2bf9a4b872$var$_enableLinkCallbacks2).call(this);
    }
}
module.exports.default = $3a13ca2bf9a4b872$var$Router;
function $3a13ca2bf9a4b872$var$_cacheUiElements2($container) {
    $3a13ca2bf9a4b872$var$_classPrivateFieldSet(this, $3a13ca2bf9a4b872$var$_ui, {
        container: $container
    });
}
function $3a13ca2bf9a4b872$var$_interceptInternalLinks2() {
    const internalOrigin = new URL(window.location.href).origin;
    let hrefs = [];
    $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_ui).container.find("a").filter((index, a)=>{
        // Skip external links
        const href = new URL(a.href, internalOrigin);
        if (href.origin != internalOrigin) return false;
        // Skip form-submit links, as these are submitted via a form.
        if ($(a).hasClass("form-submit")) return false;
        // Handle all other links
        return true;
    }).each((index, a)=>hrefs.push(a.href));
    $3a13ca2bf9a4b872$var$_classPrivateMethodGet(this, $3a13ca2bf9a4b872$var$_interceptLinks, $3a13ca2bf9a4b872$var$_interceptLinks2).call(this, hrefs);
}
function $3a13ca2bf9a4b872$var$_interceptLinks2(hrefs) {
    $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_linkInterceptCb).create("Router navigation", (href)=>{
        const url = new URL(href, window.location.origin);
        // Ignore links to the same page
        if (url.pathname !== window.location.pathname) // Load the content in the embedded view
        this.load(href);
        // Prevent the default request being sent
        return null;
    }, ...hrefs);
}
function $3a13ca2bf9a4b872$var$_enableLinkCallbacks2() {
    $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_linkInterceptCb).enable();
}
function $3a13ca2bf9a4b872$var$_disableLinkCallbacks2() {
    $3a13ca2bf9a4b872$var$_classPrivateFieldGet(this, $3a13ca2bf9a4b872$var$_linkInterceptCb).disable();
}

});
parcelRequire.register("hz37k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc981f8cd00e0c24$var$_requestService = $cc981f8cd00e0c24$var$_interopRequireDefault((parcelRequire("30IfK")));

var $cc981f8cd00e0c24$var$_utils = $cc981f8cd00e0c24$var$_interopRequireDefault((parcelRequire("6L3JM")));
function $cc981f8cd00e0c24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc981f8cd00e0c24$var$_slicedToArray(arr, i) {
    return $cc981f8cd00e0c24$var$_arrayWithHoles(arr) || $cc981f8cd00e0c24$var$_iterableToArrayLimit(arr, i) || $cc981f8cd00e0c24$var$_unsupportedIterableToArray(arr, i) || $cc981f8cd00e0c24$var$_nonIterableRest();
}
function $cc981f8cd00e0c24$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc981f8cd00e0c24$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cc981f8cd00e0c24$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cc981f8cd00e0c24$var$_arrayLikeToArray(o, minLen);
}
function $cc981f8cd00e0c24$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cc981f8cd00e0c24$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cc981f8cd00e0c24$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cc981f8cd00e0c24$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $cc981f8cd00e0c24$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $cc981f8cd00e0c24$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $cc981f8cd00e0c24$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $cc981f8cd00e0c24$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $cc981f8cd00e0c24$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $cc981f8cd00e0c24$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $cc981f8cd00e0c24$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $cc981f8cd00e0c24$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $cc981f8cd00e0c24$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $cc981f8cd00e0c24$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $cc981f8cd00e0c24$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $cc981f8cd00e0c24$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $cc981f8cd00e0c24$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $cc981f8cd00e0c24$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $cc981f8cd00e0c24$var$_uid = /*#__PURE__*/ new WeakMap();
var $cc981f8cd00e0c24$var$_$links = /*#__PURE__*/ new WeakMap();
var $cc981f8cd00e0c24$var$_pageOrigin = /*#__PURE__*/ new WeakMap();
var $cc981f8cd00e0c24$var$_onInterceptCallbacks = /*#__PURE__*/ new WeakMap();
var $cc981f8cd00e0c24$var$_onResponseCallbacks = /*#__PURE__*/ new WeakMap();
var $cc981f8cd00e0c24$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $cc981f8cd00e0c24$var$_handleLinkClick = /*#__PURE__*/ new WeakSet();
var $cc981f8cd00e0c24$var$_getMapKey = /*#__PURE__*/ new WeakSet();
class $cc981f8cd00e0c24$var$LinkInterceptor {
    // onInterceptCallbacks is a map of arrays of callbacks for a particular url
    // The callbacks are called prior to sending the GET request.
    // Callbacks are passed the href of the request object and can edit the href
    // or return a falsey value to cancel the request
    // onResponseCallbacks is a map of arrays of callbacks for a particular url
    // The callbacks are called with a promise which resolves to the response of the GET request.
    constructor(){
        $cc981f8cd00e0c24$var$_classPrivateMethodInitSpec(this, $cc981f8cd00e0c24$var$_getMapKey);
        $cc981f8cd00e0c24$var$_classPrivateMethodInitSpec(this, $cc981f8cd00e0c24$var$_handleLinkClick);
        $cc981f8cd00e0c24$var$_classPrivateMethodInitSpec(this, $cc981f8cd00e0c24$var$_bindEvents);
        $cc981f8cd00e0c24$var$_classPrivateFieldInitSpec(this, $cc981f8cd00e0c24$var$_uid, {
            writable: true,
            value: void 0
        });
        $cc981f8cd00e0c24$var$_classPrivateFieldInitSpec(this, $cc981f8cd00e0c24$var$_$links, {
            writable: true,
            value: void 0
        });
        $cc981f8cd00e0c24$var$_classPrivateFieldInitSpec(this, $cc981f8cd00e0c24$var$_pageOrigin, {
            writable: true,
            value: void 0
        });
        $cc981f8cd00e0c24$var$_classPrivateFieldInitSpec(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks, {
            writable: true,
            value: void 0
        });
        $cc981f8cd00e0c24$var$_classPrivateFieldInitSpec(this, $cc981f8cd00e0c24$var$_onResponseCallbacks, {
            writable: true,
            value: void 0
        });
        const _url = new URL(window.location.href);
        $cc981f8cd00e0c24$var$_classPrivateFieldSet(this, $cc981f8cd00e0c24$var$_uid, $cc981f8cd00e0c24$var$_utils.default.randomId());
        $cc981f8cd00e0c24$var$_classPrivateFieldSet(this, $cc981f8cd00e0c24$var$_pageOrigin, _url.origin);
    }
    init() {
        $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_bindEvents, $cc981f8cd00e0c24$var$_bindEvents2).call(this);
        $cc981f8cd00e0c24$var$_classPrivateFieldSet(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks, new Map());
        $cc981f8cd00e0c24$var$_classPrivateFieldSet(this, $cc981f8cd00e0c24$var$_onResponseCallbacks, new Map());
    }
    onIntercept(id, callback) {
        for(var _len = arguments.length, hrefs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)hrefs[_key - 2] = arguments[_key];
        for (const href of hrefs){
            const mapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, href);
            let registered = $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks).get(mapKey) ?? new Map();
            // Replaces the callback if the id already exists
            registered.set(id, callback);
            $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks).set(mapKey, registered);
        }
    }
    removeInterceptCallback(id) {
        for(var _len2 = arguments.length, hrefs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)hrefs[_key2 - 1] = arguments[_key2];
        for (const href of hrefs){
            const mapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, href);
            const registered = $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks).get(mapKey) ?? new Map();
            registered.delete(id);
            if (registered.size == 0) $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks).delete(mapKey);
        }
    }
    onResponse(id, callback) {
        for(var _len3 = arguments.length, hrefs = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)hrefs[_key3 - 2] = arguments[_key3];
        for (const href of hrefs){
            const mapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, href);
            const registered = $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onResponseCallbacks).get(mapKey) ?? new Map();
            // Replaces the callback if the id already exists
            registered.set(id, callback);
            $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onResponseCallbacks).set(mapKey, registered);
        }
    }
    removeResponseCallback(id) {
        for(var _len4 = arguments.length, hrefs = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)hrefs[_key4 - 1] = arguments[_key4];
        for (const href of hrefs){
            const mapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, href);
            const registered = $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onResponseCallbacks).get(mapKey) ?? new Map();
            registered.delete(id);
            if (registered.size == 0) $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onResponseCallbacks).delete(mapKey);
        }
    }
    rebindEvents() {
        $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_bindEvents, $cc981f8cd00e0c24$var$_bindEvents2).call(this);
    }
}
module.exports.default = $cc981f8cd00e0c24$var$LinkInterceptor;
function $cc981f8cd00e0c24$var$_bindEvents2() {
    $cc981f8cd00e0c24$var$_classPrivateFieldSet(this, $cc981f8cd00e0c24$var$_$links, $("a"));
    // Ensure don't multi-bind
    const clickEv = "click." + $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_uid);
    const keydownEv = "keydown." + $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_uid);
    $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_$links).off(clickEv);
    $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_$links).off(keydownEv);
    $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_$links).on(clickEv, (e)=>$cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_handleLinkClick, $cc981f8cd00e0c24$var$_handleLinkClick2).call(this, e));
    $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_$links).on(keydownEv, (e)=>{
        if (e.keyCode === 13) $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_handleLinkClick, $cc981f8cd00e0c24$var$_handleLinkClick2).call(this, e);
    });
}
async function $cc981f8cd00e0c24$var$_handleLinkClick2(e) {
    const href = $(e.currentTarget).attr("href");
    const mapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, href);
    const icb = $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onInterceptCallbacks).get(mapKey) ?? new Set();
    // Ignore links which have no intercept handlers
    if (icb.size == 0) return;
    e.preventDefault();
    // Call the registered intercept callbacks
    // and GET the response from the (possibly altered) url.
    // Cache the response promises, so multiple handlers don't cause multiple requests.
    const cachedResponses = new Map();
    for (const kvp of icb){
        // const id = kvp[0]; // unused
        const cb = kvp[1]; // value
        const newHref = await cb(href);
        if (newHref) {
            const newMapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, newHref);
            let responseProm = cachedResponses.get(newMapKey);
            if (!responseProm) {
                responseProm = $cc981f8cd00e0c24$var$_requestService.default.navigate(newHref);
                cachedResponses.set(newMapKey, responseProm);
            }
        }
    }
    // For each response to a different href
    // call the registered response callbacks
    for (const _ref of cachedResponses){
        var _ref2 = $cc981f8cd00e0c24$var$_slicedToArray(_ref, 2);
        const href = _ref2[0];
        const response = _ref2[1];
        {
            const mapKey = $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_getMapKey, $cc981f8cd00e0c24$var$_getMapKey2).call(this, href);
            const rcb = $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_onResponseCallbacks).get(mapKey) ?? new Set();
            for (const kvp of rcb){
                // const id = kvp[0]; // unused
                const cb = kvp[1]; // value
                await cb({
                    href: href,
                    response: response
                });
            }
        }
    }
    // Ensure any new page links are intercepted
    Promise.all(cachedResponses.values()).then(()=>{
        $cc981f8cd00e0c24$var$_classPrivateMethodGet(this, $cc981f8cd00e0c24$var$_bindEvents, $cc981f8cd00e0c24$var$_bindEvents2).call(this);
    });
}
function $cc981f8cd00e0c24$var$_getMapKey2(href) {
    // The base param in the URL constructor is used only if the link is relative
    const url = new URL(href, $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_pageOrigin));
    // If the url is internal then normalise to the use the relative path 
    if (url.origin === $cc981f8cd00e0c24$var$_classPrivateFieldGet(this, $cc981f8cd00e0c24$var$_pageOrigin)) href = url.pathname;
    return href;
}

});

parcelRequire.register("2GAMm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $1f4c088cdaf89f50$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $1f4c088cdaf89f50$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $1f4c088cdaf89f50$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $1f4c088cdaf89f50$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $1f4c088cdaf89f50$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $1f4c088cdaf89f50$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $1f4c088cdaf89f50$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $1f4c088cdaf89f50$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $1f4c088cdaf89f50$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $1f4c088cdaf89f50$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $1f4c088cdaf89f50$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $1f4c088cdaf89f50$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $1f4c088cdaf89f50$var$_id = /*#__PURE__*/ new WeakMap();
var $1f4c088cdaf89f50$var$_hrefs = /*#__PURE__*/ new WeakMap();
var $1f4c088cdaf89f50$var$_callback = /*#__PURE__*/ new WeakMap();
var $1f4c088cdaf89f50$var$_linkInterceptor = /*#__PURE__*/ new WeakMap();
class $1f4c088cdaf89f50$var$LinkInterceptCallback {
    get id() {
        return $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_id);
    }
    get callback() {
        return $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_callback);
    }
    get hrefs() {
        return $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_hrefs);
    }
    constructor(linkInterceptor){
        $1f4c088cdaf89f50$var$_classPrivateFieldInitSpec(this, $1f4c088cdaf89f50$var$_id, {
            writable: true,
            value: void 0
        });
        $1f4c088cdaf89f50$var$_classPrivateFieldInitSpec(this, $1f4c088cdaf89f50$var$_hrefs, {
            writable: true,
            value: []
        });
        $1f4c088cdaf89f50$var$_classPrivateFieldInitSpec(this, $1f4c088cdaf89f50$var$_callback, {
            writable: true,
            value: void 0
        });
        $1f4c088cdaf89f50$var$_classPrivateFieldInitSpec(this, $1f4c088cdaf89f50$var$_linkInterceptor, {
            writable: true,
            value: void 0
        });
        $1f4c088cdaf89f50$var$_classPrivateFieldSet(this, $1f4c088cdaf89f50$var$_linkInterceptor, linkInterceptor);
    }
    create(id, callback) {
        $1f4c088cdaf89f50$var$_classPrivateFieldSet(this, $1f4c088cdaf89f50$var$_id, id);
        $1f4c088cdaf89f50$var$_classPrivateFieldSet(this, $1f4c088cdaf89f50$var$_callback, callback);
        for(var _len = arguments.length, hrefs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)hrefs[_key - 2] = arguments[_key];
        $1f4c088cdaf89f50$var$_classPrivateFieldSet(this, $1f4c088cdaf89f50$var$_hrefs, hrefs);
    }
    enable() {
        $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_linkInterceptor).rebindEvents();
        $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_linkInterceptor).onIntercept($1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_id), $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_callback), ...$1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_hrefs));
    }
    disable() {
        $1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_linkInterceptor).removeInterceptCallback($1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_id), ...$1f4c088cdaf89f50$var$_classPrivateFieldGet(this, $1f4c088cdaf89f50$var$_hrefs));
    }
}
module.exports.default = $1f4c088cdaf89f50$var$LinkInterceptCallback;

});

parcelRequire.register("e7jpF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a470c72533cd68a6$var$_requestService = $a470c72533cd68a6$var$_interopRequireDefault((parcelRequire("30IfK")));

var $a470c72533cd68a6$var$_utils = $a470c72533cd68a6$var$_interopRequireDefault((parcelRequire("6L3JM")));

var $hxV1y = parcelRequire("hxV1y");
function $a470c72533cd68a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a470c72533cd68a6$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $a470c72533cd68a6$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $a470c72533cd68a6$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $a470c72533cd68a6$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $a470c72533cd68a6$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $a470c72533cd68a6$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $a470c72533cd68a6$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $a470c72533cd68a6$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $a470c72533cd68a6$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $a470c72533cd68a6$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $a470c72533cd68a6$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $a470c72533cd68a6$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $a470c72533cd68a6$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $a470c72533cd68a6$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $a470c72533cd68a6$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $a470c72533cd68a6$var$_ui = /*#__PURE__*/ new WeakMap();
var $a470c72533cd68a6$var$_requestType = /*#__PURE__*/ new WeakMap();
var $a470c72533cd68a6$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $a470c72533cd68a6$var$_setContent = /*#__PURE__*/ new WeakSet();
var $a470c72533cd68a6$var$_setContentOnLoad = /*#__PURE__*/ new WeakSet();
var $a470c72533cd68a6$var$_setUiLoading = /*#__PURE__*/ new WeakSet();
var $a470c72533cd68a6$var$_setUiLoaded = /*#__PURE__*/ new WeakSet();
var $a470c72533cd68a6$var$_scrollToContent = /*#__PURE__*/ new WeakSet();
var $a470c72533cd68a6$var$_handleContentLoadError = /*#__PURE__*/ new WeakSet();
class $a470c72533cd68a6$var$EmbeddedContentView {
    constructor(){
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_handleContentLoadError);
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_scrollToContent);
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_setUiLoaded);
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_setUiLoading);
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_setContentOnLoad);
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_setContent);
        $a470c72533cd68a6$var$_classPrivateMethodInitSpec(this, $a470c72533cd68a6$var$_cacheUiElements);
        $a470c72533cd68a6$var$_classPrivateFieldInitSpec(this, $a470c72533cd68a6$var$_ui, {
            writable: true,
            value: void 0
        });
        $a470c72533cd68a6$var$_classPrivateFieldInitSpec(this, $a470c72533cd68a6$var$_requestType, {
            writable: true,
            value: $hxV1y.RouterRequestType.Standard
        });
    }
    init($container) {
        let isModal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (isModal) $a470c72533cd68a6$var$_classPrivateFieldSet(this, $a470c72533cd68a6$var$_requestType, $hxV1y.RouterRequestType.Modal);
        $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_cacheUiElements, $a470c72533cd68a6$var$_cacheUiElements2).call(this, $container);
    }
    async load(url) {
        let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let http_method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
        await $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setContentOnLoad, $a470c72533cd68a6$var$_setContentOnLoad2).call(this, url, data, http_method);
    }
}
module.exports.default = $a470c72533cd68a6$var$EmbeddedContentView;
function $a470c72533cd68a6$var$_cacheUiElements2($container) {
    $a470c72533cd68a6$var$_classPrivateFieldSet(this, $a470c72533cd68a6$var$_ui, {
        container: $container,
        content: $container.find("#content"),
        spinner: $container.find(".spinner")
    });
}
function $a470c72533cd68a6$var$_setContent2(newContent) {
    $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).content.html(newContent);
    // Reparse a new form (if it exists) to apply the validators
    let $form = $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).container.find("form");
    if ($form.length > 0) $.validator.unobtrusive.parse($form);
}
async function $a470c72533cd68a6$var$_setContentOnLoad2(url) {
    let additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let http_method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
    let content;
    let urlObj;
    // Set the routing type
    let data = {};
    data["r"] = $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_requestType);
    data = {
        ...data,
        ...additionalData
    };
    $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setUiLoading, $a470c72533cd68a6$var$_setUiLoading2).call(this);
    try {
        urlObj = $a470c72533cd68a6$var$_utils.default.newURL(url);
        if (http_method === "POST") content = await $a470c72533cd68a6$var$_requestService.default.post(urlObj, data);
        else content = await $a470c72533cd68a6$var$_requestService.default.navigate(urlObj, data);
        $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setContent, $a470c72533cd68a6$var$_setContent2).call(this, content);
        $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).container.trigger("content-loaded", {
            url: urlObj
        });
    } catch (errResp) {
        $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setUiLoaded, $a470c72533cd68a6$var$_setUiLoaded2).call(this);
        switch(errResp.status){
            // Unauthorised / Redirect
            case 401:
            case 302:
                // Navigate to the login/redirect location
                await $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setContentOnLoad, $a470c72533cd68a6$var$_setContentOnLoad2).call(this, errResp.responseJSON.location);
                break;
            default:
                $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_handleContentLoadError, $a470c72533cd68a6$var$_handleContentLoadError2).call(this, errResp, urlObj);
        }
    } finally{
        $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setUiLoaded, $a470c72533cd68a6$var$_setUiLoaded2).call(this);
    }
}
function $a470c72533cd68a6$var$_setUiLoading2() {
    $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).spinner.removeClass("hidden");
    $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).content.addClass("hidden");
}
function $a470c72533cd68a6$var$_setUiLoaded2() {
    $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).spinner.addClass("hidden");
    $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).content.removeClass("hidden");
}
function $a470c72533cd68a6$var$_scrollToContent2() {
    window.scroller.scrollToElemTop($a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).content);
}
function $a470c72533cd68a6$var$_handleContentLoadError2(errResp, urlObj) {
    // There is an error page, so we can display it.
    if (errResp.contentType != null && errResp.contentType.includes("text/html")) {
        $a470c72533cd68a6$var$_classPrivateMethodGet(this, $a470c72533cd68a6$var$_setContent, $a470c72533cd68a6$var$_setContent2).call(this, errResp.responseText);
        $a470c72533cd68a6$var$_classPrivateFieldGet(this, $a470c72533cd68a6$var$_ui).container.trigger("content-loaded", {
            url: urlObj
        });
        return;
    }
    // Else there is no error page.
    // This needs to be handled by the page
    throw errResp;
}

});


parcelRequire.register("gOADx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3ddbc29ccef6295$var$_utils = $c3ddbc29ccef6295$var$_interopRequireDefault((parcelRequire("6L3JM")));
function $c3ddbc29ccef6295$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c3ddbc29ccef6295$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $c3ddbc29ccef6295$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $c3ddbc29ccef6295$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $c3ddbc29ccef6295$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $c3ddbc29ccef6295$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $c3ddbc29ccef6295$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $c3ddbc29ccef6295$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $c3ddbc29ccef6295$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $c3ddbc29ccef6295$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $c3ddbc29ccef6295$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $c3ddbc29ccef6295$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $c3ddbc29ccef6295$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $c3ddbc29ccef6295$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $c3ddbc29ccef6295$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $c3ddbc29ccef6295$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $c3ddbc29ccef6295$var$_ui = /*#__PURE__*/ new WeakMap();
var $c3ddbc29ccef6295$var$_abortController = /*#__PURE__*/ new WeakMap();
var $c3ddbc29ccef6295$var$_isOpen = /*#__PURE__*/ new WeakMap();
var $c3ddbc29ccef6295$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $c3ddbc29ccef6295$var$_bindEvents = /*#__PURE__*/ new WeakSet();
class $c3ddbc29ccef6295$var$Modal {
    get abortController() {
        return $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_abortController);
    }
    get eventTarget() {
        return $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal;
    }
    constructor(){
        $c3ddbc29ccef6295$var$_classPrivateMethodInitSpec(this, $c3ddbc29ccef6295$var$_bindEvents);
        $c3ddbc29ccef6295$var$_classPrivateMethodInitSpec(this, $c3ddbc29ccef6295$var$_cacheUiElements);
        $c3ddbc29ccef6295$var$_classPrivateFieldInitSpec(this, $c3ddbc29ccef6295$var$_ui, {
            writable: true,
            value: void 0
        });
        $c3ddbc29ccef6295$var$_classPrivateFieldInitSpec(this, $c3ddbc29ccef6295$var$_abortController, {
            writable: true,
            value: void 0
        });
        $c3ddbc29ccef6295$var$_classPrivateFieldInitSpec(this, $c3ddbc29ccef6295$var$_isOpen, {
            writable: true,
            value: false
        });
        $c3ddbc29ccef6295$var$_classPrivateMethodGet(this, $c3ddbc29ccef6295$var$_cacheUiElements, $c3ddbc29ccef6295$var$_cacheUiElements2).call(this);
        $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal.modal({
            backdrop: "static",
            keyboard: false,
            show: false
        });
    }
    async open() {
        $c3ddbc29ccef6295$var$_classPrivateFieldSet(this, $c3ddbc29ccef6295$var$_abortController, new AbortController());
        $c3ddbc29ccef6295$var$_classPrivateMethodGet(this, $c3ddbc29ccef6295$var$_bindEvents, $c3ddbc29ccef6295$var$_bindEvents2).call(this);
        if ($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_isOpen)) // Already open
        return Promise.resolve();
        $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal.modal("show");
        // Wait for the modal to fully open
        return await $c3ddbc29ccef6295$var$_utils.default.promisifyEvent($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal, "shown.bs.modal");
    }
    async close() {
        if ($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_isOpen)) {
            $c3ddbc29ccef6295$var$_classPrivateFieldSet(this, $c3ddbc29ccef6295$var$_isOpen, false);
            $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal.modal("hide");
            // Wait for the modal to fully close
            return await $c3ddbc29ccef6295$var$_utils.default.promisifyEvent($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal, "hidden.bs.modal");
        }
        // Already closed
        return Promise.resolve();
    }
    setContent(title, $cleanContent) {
        $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).title.text(title);
        $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).contentWrap.html($cleanContent);
    }
    scrollToContent() {
        window.scroller.scrollToElemTop($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modalContent);
    }
}
module.exports.default = $c3ddbc29ccef6295$var$Modal;
function $c3ddbc29ccef6295$var$_cacheUiElements2() {
    $c3ddbc29ccef6295$var$_classPrivateFieldSet(this, $c3ddbc29ccef6295$var$_ui, {
        modal: $("#booking-modal"),
        modalContent: $("#booking-modal .modal-content"),
        contentWrap: $("#booking-modal #content-wrap"),
        title: $(".modal-title")
    });
}
function $c3ddbc29ccef6295$var$_bindEvents2() {
    const hideModalHandler = ()=>{
        $c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_abortController).abort();
        $($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal).off("hide.bs.modal", hideModalHandler);
    };
    const shownModalHandler = ()=>{
        $c3ddbc29ccef6295$var$_classPrivateFieldSet(this, $c3ddbc29ccef6295$var$_isOpen, true);
        this.scrollToContent();
    };
    // Toggle off/on to ensure bound only once
    $($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal).off("hide.bs.modal").on("hide.bs.modal", hideModalHandler);
    $($c3ddbc29ccef6295$var$_classPrivateFieldGet(this, $c3ddbc29ccef6295$var$_ui).modal).off("shown.bs.modal").on("shown.bs.modal", shownModalHandler);
}

});


parcelRequire.register("bvkTP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8602cd28d548e403$var$_iframeModal = $8602cd28d548e403$var$_interopRequireDefault((parcelRequire("bi8Kz")));
function $8602cd28d548e403$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8602cd28d548e403$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $8602cd28d548e403$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $8602cd28d548e403$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $8602cd28d548e403$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $8602cd28d548e403$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $8602cd28d548e403$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $8602cd28d548e403$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $8602cd28d548e403$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $8602cd28d548e403$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $8602cd28d548e403$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $8602cd28d548e403$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $8602cd28d548e403$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $8602cd28d548e403$var$_url = /*#__PURE__*/ new WeakMap();
class $8602cd28d548e403$var$PaymentModal extends $8602cd28d548e403$var$_iframeModal.default {
    constructor(paymentUrl){
        super();
        $8602cd28d548e403$var$_classPrivateFieldInitSpec(this, $8602cd28d548e403$var$_url, {
            writable: true,
            value: void 0
        });
        $8602cd28d548e403$var$_classPrivateFieldSet(this, $8602cd28d548e403$var$_url, paymentUrl);
    }
    async requestPayment() {
        this.autoResizeHeight = false;
        await this.open("Pay your deposit", $8602cd28d548e403$var$_classPrivateFieldGet(this, $8602cd28d548e403$var$_url));
        let lastErr = "";
        let retryingPayment = true;
        let paid = false;
        while(retryingPayment)try {
            // eslint-disable-next-line no-await-in-loop
            await this.awaitSuccessStatus();
            paid = true;
            retryingPayment = false;
        } catch (error) {
            if (error.message === "Aborted") {
                retryingPayment = false;
                error.message = "Payment cancelled.";
            }
            lastErr = error;
        }
        if (!paid) throw lastErr;
    // Payment Success
    }
}
module.exports.default = $8602cd28d548e403$var$PaymentModal;

});
parcelRequire.register("bi8Kz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $838829c1f673f400$var$_modal = $838829c1f673f400$var$_interopRequireDefault((parcelRequire("gOADx")));

var $838829c1f673f400$var$_utils = $838829c1f673f400$var$_interopRequireDefault((parcelRequire("6L3JM")));
function $838829c1f673f400$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $838829c1f673f400$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $838829c1f673f400$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $838829c1f673f400$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $838829c1f673f400$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $838829c1f673f400$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $838829c1f673f400$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $838829c1f673f400$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $838829c1f673f400$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $838829c1f673f400$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $838829c1f673f400$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $838829c1f673f400$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $838829c1f673f400$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $838829c1f673f400$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $838829c1f673f400$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $838829c1f673f400$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $838829c1f673f400$var$_url = /*#__PURE__*/ new WeakMap();
var $838829c1f673f400$var$_status = /*#__PURE__*/ new WeakMap();
var $838829c1f673f400$var$_getIframe = /*#__PURE__*/ new WeakSet();
var $838829c1f673f400$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $838829c1f673f400$var$_resetStatus = /*#__PURE__*/ new WeakSet();
var $838829c1f673f400$var$_getStatus = /*#__PURE__*/ new WeakSet();
class $838829c1f673f400$var$IframeModal extends $838829c1f673f400$var$_modal.default {
    constructor(){
        super(...arguments);
        $838829c1f673f400$var$_classPrivateMethodInitSpec(this, $838829c1f673f400$var$_getStatus);
        $838829c1f673f400$var$_classPrivateMethodInitSpec(this, $838829c1f673f400$var$_resetStatus);
        $838829c1f673f400$var$_classPrivateMethodInitSpec(this, $838829c1f673f400$var$_bindEvents);
        $838829c1f673f400$var$_classPrivateMethodInitSpec(this, $838829c1f673f400$var$_getIframe);
        $838829c1f673f400$var$_classPrivateFieldInitSpec(this, $838829c1f673f400$var$_url, {
            writable: true,
            value: void 0
        });
        $838829c1f673f400$var$_classPrivateFieldInitSpec(this, $838829c1f673f400$var$_status, {
            writable: true,
            value: {}
        });
    }
    async open(title, url) {
        const baseUrl = window.location.origin;
        $838829c1f673f400$var$_classPrivateFieldSet(this, $838829c1f673f400$var$_url, new URL(url, baseUrl));
        $838829c1f673f400$var$_classPrivateMethodGet(this, $838829c1f673f400$var$_bindEvents, $838829c1f673f400$var$_bindEvents2).call(this);
        const $content = $838829c1f673f400$var$_classPrivateMethodGet(this, $838829c1f673f400$var$_getIframe, $838829c1f673f400$var$_getIframe2).call(this, $838829c1f673f400$var$_classPrivateFieldGet(this, $838829c1f673f400$var$_url).href);
        this.setContent(title, $content);
        await super.open();
    }
    async awaitSuccessStatus() {
        if ($.isEmptyObject($838829c1f673f400$var$_classPrivateFieldGet(this, $838829c1f673f400$var$_status))) {
            // Wait for a status message
            let waiting = true;
            while(waiting){
                // eslint-disable-next-line no-await-in-loop
                await $838829c1f673f400$var$_classPrivateMethodGet(this, $838829c1f673f400$var$_getStatus, $838829c1f673f400$var$_getStatus2).call(this);
                waiting = false;
            }
        }
        // Handle an error status
        if ($838829c1f673f400$var$_classPrivateFieldGet(this, $838829c1f673f400$var$_status).status !== "success") {
            const message = $838829c1f673f400$var$_classPrivateFieldGet(this, $838829c1f673f400$var$_status).message;
            $838829c1f673f400$var$_classPrivateMethodGet(this, $838829c1f673f400$var$_resetStatus, $838829c1f673f400$var$_resetStatus2).call(this);
            throw new Error(message);
        }
    // Otherwise, success!
    }
}
module.exports.default = $838829c1f673f400$var$IframeModal;
function $838829c1f673f400$var$_getIframe2(href) {
    const $iframe = $(`<iframe class="row mx-auto" allow="payment"></iframe>`);
    const cleanHref = DOMPurify.sanitize(href);
    $iframe.attr("src", cleanHref);
    return $iframe;
}
function $838829c1f673f400$var$_bindEvents2() {
    // Process events from window messages
    $838829c1f673f400$var$_classPrivateMethodGet(this, $838829c1f673f400$var$_resetStatus, $838829c1f673f400$var$_resetStatus2).call(this);
    const windowMessageHandler = (e)=>{
        const _e$originalEvent = e.originalEvent, data = _e$originalEvent.data, origin = _e$originalEvent.origin;
        // Only action window messages from the iframe origin
        if (origin === $838829c1f673f400$var$_classPrivateFieldGet(this, $838829c1f673f400$var$_url).origin) // Trigger corresponding events
        {
            if ("status" in data) {
                $838829c1f673f400$var$_classPrivateFieldSet(this, $838829c1f673f400$var$_status, {
                    status: data.status,
                    message: data.message
                });
                this.eventTarget.triggerHandler("status");
            }
        }
    };
    // Toggle off/on to ensure bound only once
    $(window).off("message", windowMessageHandler).on("message", windowMessageHandler);
}
function $838829c1f673f400$var$_resetStatus2() {
    $838829c1f673f400$var$_classPrivateFieldSet(this, $838829c1f673f400$var$_status, {});
}
async function $838829c1f673f400$var$_getStatus2() {
    return $838829c1f673f400$var$_utils.default.promisifyEvent(this.eventTarget, "status", this.abortController.signal);
}

});


parcelRequire.register("o3NoA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04852fc0bc053145$var$_domUtils = $04852fc0bc053145$var$_interopRequireDefault((parcelRequire("imrQw")));
function $04852fc0bc053145$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $04852fc0bc053145$var$MessagePoster {
    static postScrollTo(top) {
        let padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
        const msg = {
            scrollTo: top - padding
        };
        $04852fc0bc053145$var$MessagePoster.postMessage(msg);
    }
    static postHeight(height) {
        const msg = {
            height: height
        };
        $04852fc0bc053145$var$MessagePoster.postMessage(msg);
    }
    static postBookingStatusBooked(data) {
        const msg = {
            bookingStatus: "booked",
            data: data
        };
        $04852fc0bc053145$var$MessagePoster.postMessage(msg);
    }
    static postRedirect(url) {
        const msg = {
            redirect: url
        };
        $04852fc0bc053145$var$MessagePoster.postMessage(msg);
    }
    static postMessage(msg) {
        if (window !== window.parent) window.parent.postMessage(msg, "*");
    }
}
module.exports.default = $04852fc0bc053145$var$MessagePoster;

});
parcelRequire.register("imrQw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
class $d5dfe1c0c787b2f8$var$DOMUtils {
    static getElemTop(elem) {
        const $elem = elem instanceof jQuery ? elem : $(elem);
        if ($elem.length > 0) return $elem.offset().top;
        return 0;
    }
    /**
   * Gets the combined content height of visible top level children
   * that are in the standard page flow.
   */ static getContentHeight(elem) {
        const $elem = elem instanceof jQuery ? elem : $(elem);
        let contentHeight = 0;
        $elem.children("*").not(":hidden").each((index, el)=>{
            const $this = $(el);
            if ($this.css("position") === "static" || $this.css("position") === "sticky") contentHeight += $this.outerHeight(true);
        });
        return contentHeight;
    }
    /**
   * Observes elem and calls the given callback function every time elem's height changes.
   */ static onContentHeightChange(elem, callback) {
        const $elem = elem instanceof jQuery ? elem : $(elem);
        $(()=>{
            // Send initial height then wait for changes
            // Keep polling the height until it is loaded
            const t = setInterval(()=>{
                let lastHeight = $d5dfe1c0c787b2f8$var$DOMUtils.getContentHeight($elem);
                if (lastHeight === 0) return;
                clearInterval(t);
                callback(lastHeight);
                const observer = new MutationObserver(()=>{
                    // Callback with the new height when it changes
                    const height = $d5dfe1c0c787b2f8$var$DOMUtils.getContentHeight($elem);
                    if (height !== lastHeight) {
                        callback(height);
                        lastHeight = height;
                    }
                });
                // Which mutations to observe
                const config = {
                    attributes: true,
                    childList: true,
                    subtree: true
                };
                // Start observing the element
                observer.observe($elem[0], config);
            }, 1);
        });
    }
    static getStylesheetElem() {
        let hrefIncludes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        const $elems = $("head link[rel='stylesheet']");
        return $elems.filter((index, elem)=>{
            const href = $(elem).attr("href");
            return href.includes(hrefIncludes);
        });
    }
}
module.exports.default = $d5dfe1c0c787b2f8$var$DOMUtils;

});


parcelRequire.register("jwHwL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e372c52262aaaa40$var$_appointmentsService = $e372c52262aaaa40$var$_interopRequireDefault((parcelRequire("bPqot")));

var $e372c52262aaaa40$var$_utils = $e372c52262aaaa40$var$_interopRequireDefault((parcelRequire("6L3JM")));

var $e372c52262aaaa40$var$_modal = $e372c52262aaaa40$var$_interopRequireDefault((parcelRequire("gOADx")));
function $e372c52262aaaa40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e372c52262aaaa40$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $e372c52262aaaa40$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $e372c52262aaaa40$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $e372c52262aaaa40$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $e372c52262aaaa40$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $e372c52262aaaa40$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $e372c52262aaaa40$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $e372c52262aaaa40$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $e372c52262aaaa40$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $e372c52262aaaa40$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $e372c52262aaaa40$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $e372c52262aaaa40$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $e372c52262aaaa40$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $e372c52262aaaa40$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $e372c52262aaaa40$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $e372c52262aaaa40$var$_title = /*#__PURE__*/ new WeakMap();
var $e372c52262aaaa40$var$_termsAccepted = /*#__PURE__*/ new WeakMap();
var $e372c52262aaaa40$var$_$container = /*#__PURE__*/ new WeakMap();
var $e372c52262aaaa40$var$_interceptSubmit = /*#__PURE__*/ new WeakSet();
var $e372c52262aaaa40$var$_acceptTerms = /*#__PURE__*/ new WeakSet();
var $e372c52262aaaa40$var$_awaitAcceptance = /*#__PURE__*/ new WeakSet();
var $e372c52262aaaa40$var$_getContent = /*#__PURE__*/ new WeakSet();
class $e372c52262aaaa40$var$TermsModal extends $e372c52262aaaa40$var$_modal.default {
    constructor(){
        super();
        $e372c52262aaaa40$var$_classPrivateMethodInitSpec(this, $e372c52262aaaa40$var$_getContent);
        $e372c52262aaaa40$var$_classPrivateMethodInitSpec(this, $e372c52262aaaa40$var$_awaitAcceptance);
        $e372c52262aaaa40$var$_classPrivateMethodInitSpec(this, $e372c52262aaaa40$var$_acceptTerms);
        $e372c52262aaaa40$var$_classPrivateMethodInitSpec(this, $e372c52262aaaa40$var$_interceptSubmit);
        $e372c52262aaaa40$var$_classPrivateFieldInitSpec(this, $e372c52262aaaa40$var$_title, {
            writable: true,
            value: void 0
        });
        $e372c52262aaaa40$var$_classPrivateFieldInitSpec(this, $e372c52262aaaa40$var$_termsAccepted, {
            writable: true,
            value: false
        });
        $e372c52262aaaa40$var$_classPrivateFieldInitSpec(this, $e372c52262aaaa40$var$_$container, {
            writable: true,
            value: void 0
        });
        $e372c52262aaaa40$var$_classPrivateFieldSet(this, $e372c52262aaaa40$var$_title, "Terms and conditions");
        $e372c52262aaaa40$var$_classPrivateFieldSet(this, $e372c52262aaaa40$var$_$container, $e372c52262aaaa40$var$_classPrivateMethodGet(this, $e372c52262aaaa40$var$_getContent, $e372c52262aaaa40$var$_getContent2).call(this));
    }
    init() {
        this.setContent($e372c52262aaaa40$var$_classPrivateFieldGet(this, $e372c52262aaaa40$var$_title), $e372c52262aaaa40$var$_classPrivateFieldGet(this, $e372c52262aaaa40$var$_$container));
    }
    async open(appointmentId) {
        $e372c52262aaaa40$var$_classPrivateFieldSet(this, $e372c52262aaaa40$var$_termsAccepted, false);
        let content;
        try {
            content = await $e372c52262aaaa40$var$_appointmentsService.default.getTerms();
        } catch (errResp) {
            // If no booking terms found, auto accept.
            if (errResp.status == 404) {
                $e372c52262aaaa40$var$_classPrivateMethodGet(this, $e372c52262aaaa40$var$_acceptTerms, $e372c52262aaaa40$var$_acceptTerms2).call(this);
                return;
            }
            // Otherwise handle the error as usual.
            throw errResp;
        }
        await super.open();
        this.setContent($e372c52262aaaa40$var$_classPrivateFieldGet(this, $e372c52262aaaa40$var$_title), $e372c52262aaaa40$var$_classPrivateFieldGet(this, $e372c52262aaaa40$var$_$container).append(content));
        $e372c52262aaaa40$var$_classPrivateMethodGet(this, $e372c52262aaaa40$var$_interceptSubmit, $e372c52262aaaa40$var$_interceptSubmit2).call(this, appointmentId);
    }
    async requestAcceptance(appointmentId) {
        await this.open(appointmentId);
        try {
            await $e372c52262aaaa40$var$_classPrivateMethodGet(this, $e372c52262aaaa40$var$_awaitAcceptance, $e372c52262aaaa40$var$_awaitAcceptance2).call(this);
        } catch (error) {
            if (error.message === "Aborted") error.message = "Booking terms closed.";
            throw error;
        } finally{
            await this.close();
        }
    // Booking terms accepted
    }
}
module.exports.default = $e372c52262aaaa40$var$TermsModal;
function $e372c52262aaaa40$var$_interceptSubmit2(appointmentId) {
    $("#terms-form").off("submit").on("submit", async (e)=>{
        e.preventDefault();
        await $e372c52262aaaa40$var$_appointmentsService.default.acceptBookingTerms(appointmentId);
        await $e372c52262aaaa40$var$_classPrivateMethodGet(this, $e372c52262aaaa40$var$_acceptTerms, $e372c52262aaaa40$var$_acceptTerms2).call(this);
    });
}
async function $e372c52262aaaa40$var$_acceptTerms2() {
    $e372c52262aaaa40$var$_classPrivateFieldSet(this, $e372c52262aaaa40$var$_termsAccepted, true);
    this.eventTarget.triggerHandler("accept");
}
async function $e372c52262aaaa40$var$_awaitAcceptance2() {
    if ($e372c52262aaaa40$var$_classPrivateFieldGet(this, $e372c52262aaaa40$var$_termsAccepted)) return Promise.resolve();
    return $e372c52262aaaa40$var$_utils.default.promisifyEvent(this.eventTarget, "accept", this.abortController.signal);
}
function $e372c52262aaaa40$var$_getContent2() {
    return $(`<div id="content" class="row p-3"></div>`);
}

});

parcelRequire.register("h7UYA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AnimatedBorder = void 0;
function $c77f496bb677fe6e$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $c77f496bb677fe6e$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $c77f496bb677fe6e$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $c77f496bb677fe6e$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $c77f496bb677fe6e$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $c77f496bb677fe6e$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $c77f496bb677fe6e$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $c77f496bb677fe6e$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $c77f496bb677fe6e$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $c77f496bb677fe6e$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $c77f496bb677fe6e$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $c77f496bb677fe6e$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $c77f496bb677fe6e$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $c77f496bb677fe6e$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $c77f496bb677fe6e$var$_options = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_keyframes = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_$elem = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_$border = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_pulses = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_animations = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_observer = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_size = /*#__PURE__*/ new WeakMap();
var $c77f496bb677fe6e$var$_getKeyframes = /*#__PURE__*/ new WeakSet();
var $c77f496bb677fe6e$var$_animatePulses = /*#__PURE__*/ new WeakSet();
var $c77f496bb677fe6e$var$_handleResize = /*#__PURE__*/ new WeakSet();
var $c77f496bb677fe6e$var$_addMarkup = /*#__PURE__*/ new WeakSet();
class $c77f496bb677fe6e$var$AnimatedBorder {
    constructor(){
        let duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
        let pulses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        $c77f496bb677fe6e$var$_classPrivateMethodInitSpec(this, $c77f496bb677fe6e$var$_addMarkup);
        $c77f496bb677fe6e$var$_classPrivateMethodInitSpec(this, $c77f496bb677fe6e$var$_handleResize);
        $c77f496bb677fe6e$var$_classPrivateMethodInitSpec(this, $c77f496bb677fe6e$var$_animatePulses);
        $c77f496bb677fe6e$var$_classPrivateMethodInitSpec(this, $c77f496bb677fe6e$var$_getKeyframes);
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_options, {
            writable: true,
            value: void 0
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_keyframes, {
            writable: true,
            value: void 0
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_$elem, {
            writable: true,
            value: void 0
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_$border, {
            writable: true,
            value: void 0
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_pulses, {
            writable: true,
            value: []
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_animations, {
            writable: true,
            value: []
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_observer, {
            writable: true,
            value: void 0
        });
        $c77f496bb677fe6e$var$_classPrivateFieldInitSpec(this, $c77f496bb677fe6e$var$_size, {
            writable: true,
            value: void 0
        });
        $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_options, {
            duration: duration,
            pulses: pulses
        });
    }
    attach(elem) {
        const $elem = elem instanceof jQuery ? elem : $(elem);
        if ($elem.length == 0) return;
        $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_$elem, $elem);
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).addClass("anim-border");
        $c77f496bb677fe6e$var$_classPrivateMethodGet(this, $c77f496bb677fe6e$var$_addMarkup, $c77f496bb677fe6e$var$_addMarkup2).call(this);
        $c77f496bb677fe6e$var$_classPrivateMethodGet(this, $c77f496bb677fe6e$var$_getKeyframes, $c77f496bb677fe6e$var$_getKeyframes2).call(this);
        $c77f496bb677fe6e$var$_classPrivateMethodGet(this, $c77f496bb677fe6e$var$_animatePulses, $c77f496bb677fe6e$var$_animatePulses2).call(this);
        $c77f496bb677fe6e$var$_classPrivateMethodGet(this, $c77f496bb677fe6e$var$_handleResize, $c77f496bb677fe6e$var$_handleResize2).call(this);
    }
    remove() {
        if ($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$border) == null) return;
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).removeClass("anim-border");
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_observer).disconnect();
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses).forEach(($p)=>{
            $p.remove();
        });
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$border).remove();
        $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_pulses, []);
        $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_$border, null);
    }
    play() {
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses);
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses).forEach(($p)=>{
            $p.css({
                display: "unset"
            });
        });
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_animations).forEach((anim)=>{
            anim.play();
        });
    }
    pause() {
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses).forEach(($p)=>{
            $p.css({
                display: "none"
            });
        });
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_animations).forEach((anim)=>{
            anim.pause();
        });
    }
}
module.exports.AnimatedBorder = $c77f496bb677fe6e$var$AnimatedBorder;
function $c77f496bb677fe6e$var$_getKeyframes2() {
    $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_size, {
        width: $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).outerWidth(),
        height: $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).outerHeight()
    });
    const leftBorder = parseInt($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).css("border-left-width"));
    const rightBorder = parseInt($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).css("border-right-width"));
    const topBorder = parseInt($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).css("border-top-width"));
    const bottomBorder = parseInt($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).css("border-bottom-width"));
    const w = $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_size).width - leftBorder - rightBorder;
    const h = $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_size).height - topBorder - bottomBorder;
    const pathTotal = (w + h) * 2;
    const wRatio = w / pathTotal;
    const hRatio = h / pathTotal;
    $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_keyframes, [
        {
            transform: "translate(-5px, -5px)",
            offset: 0
        },
        {
            transform: `translate(${w}px, -5px)`,
            offset: wRatio
        },
        {
            transform: `translate(${w}px, ${h}px)`,
            offset: wRatio + hRatio
        },
        {
            transform: `translate(-5px, ${h}px)`,
            offset: wRatio + hRatio + wRatio
        },
        {
            transform: "translate(-5px, -5px)",
            offset: 1
        }
    ]);
}
function $c77f496bb677fe6e$var$_animatePulses2() {
    const numPulses = $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses).length;
    const delayEach = $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_options).duration / numPulses;
    $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses).forEach(($p, index)=>{
        const timing = {
            duration: $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_options).duration,
            iterations: Infinity,
            // Negative delay causes the animation to
            // jump straight to this point.
            delay: -(index * delayEach)
        };
        const anim = $p[0].animate($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_keyframes), timing);
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_animations).push(anim);
    });
}
function $c77f496bb677fe6e$var$_handleResize2() {
    $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_observer, new ResizeObserver((entries)=>{
        const $entry = $(entries[0].target);
        if ($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_size).width != $entry.outerWidth() || $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_size).height != $entry.outerHeight()) {
            this.remove();
            this.attach($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem));
        }
    }));
    $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_observer).observe($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem)[0]);
}
function $c77f496bb677fe6e$var$_addMarkup2() {
    const $pulse = $("<div class='pulse'></div>");
    $pulse.css({
        position: "absolute",
        top: "0px",
        left: "0px",
        height: "5px",
        width: "5px",
        background: "var(--bs-info)",
        "border-radius": "50%",
        "box-shadow": "0 0 8px 4px var(--bs-info)",
        "z-index": 1
    });
    $c77f496bb677fe6e$var$_classPrivateFieldSet(this, $c77f496bb677fe6e$var$_$border, $("<div></div>"));
    $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$border).css({
        position: "absolute",
        inset: "0px",
        width: "100%",
        height: "100%",
        /* color-mix() mixes two colours but I'm mixing the info colour with transparent to just make it 25% opacity */ "box-shadow": "0 0 0 5px color-mix(in srgb-linear, var(--bs-info) 25%, transparent)",
        "border-radius": $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).css("border-radius"),
        "z-index": -1
    });
    $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).css({
        "z-index": 0
    });
    $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem).append($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$border));
    for(var i = 0; i < $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_options).pulses; i++){
        const $p = $pulse.clone().appendTo($c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_$elem));
        $c77f496bb677fe6e$var$_classPrivateFieldGet(this, $c77f496bb677fe6e$var$_pulses).push($p);
    }
}

});


parcelRequire.register("dv63s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $9d42ddfa4940730c$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $9d42ddfa4940730c$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $9d42ddfa4940730c$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $9d42ddfa4940730c$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $9d42ddfa4940730c$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $9d42ddfa4940730c$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $9d42ddfa4940730c$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $9d42ddfa4940730c$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $9d42ddfa4940730c$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $9d42ddfa4940730c$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $9d42ddfa4940730c$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $9d42ddfa4940730c$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $9d42ddfa4940730c$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $9d42ddfa4940730c$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $9d42ddfa4940730c$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
var $9d42ddfa4940730c$var$_ui = /*#__PURE__*/ new WeakMap();
var $9d42ddfa4940730c$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $9d42ddfa4940730c$var$_bindEvents = /*#__PURE__*/ new WeakSet();
class $9d42ddfa4940730c$var$AppointmentConfirmation {
    constructor(){
        $9d42ddfa4940730c$var$_classPrivateMethodInitSpec(this, $9d42ddfa4940730c$var$_bindEvents);
        $9d42ddfa4940730c$var$_classPrivateMethodInitSpec(this, $9d42ddfa4940730c$var$_cacheUiElements);
        $9d42ddfa4940730c$var$_classPrivateFieldInitSpec(this, $9d42ddfa4940730c$var$_ui, {
            writable: true,
            value: void 0
        });
    }
    init() {
        $9d42ddfa4940730c$var$_classPrivateMethodGet(this, $9d42ddfa4940730c$var$_cacheUiElements, $9d42ddfa4940730c$var$_cacheUiElements2).call(this);
        $9d42ddfa4940730c$var$_classPrivateMethodGet(this, $9d42ddfa4940730c$var$_bindEvents, $9d42ddfa4940730c$var$_bindEvents2).call(this);
    }
}
module.exports.default = $9d42ddfa4940730c$var$AppointmentConfirmation;
function $9d42ddfa4940730c$var$_cacheUiElements2() {
    $9d42ddfa4940730c$var$_classPrivateFieldSet(this, $9d42ddfa4940730c$var$_ui, {
        printButton: $("button.print")
    });
}
function $9d42ddfa4940730c$var$_bindEvents2() {
    $9d42ddfa4940730c$var$_classPrivateFieldGet(this, $9d42ddfa4940730c$var$_ui).printButton.on("click", ()=>{
        window.print();
    });
}

});

parcelRequire.register("8VCwX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $680188fe3fcbbe61$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $680188fe3fcbbe61$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $680188fe3fcbbe61$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $680188fe3fcbbe61$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $680188fe3fcbbe61$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $680188fe3fcbbe61$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $680188fe3fcbbe61$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $680188fe3fcbbe61$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $680188fe3fcbbe61$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $680188fe3fcbbe61$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $680188fe3fcbbe61$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $680188fe3fcbbe61$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
var $680188fe3fcbbe61$var$_returnUrl = /*#__PURE__*/ new WeakMap();
var $680188fe3fcbbe61$var$_hideNavbar = /*#__PURE__*/ new WeakMap();
var $680188fe3fcbbe61$var$_hideLogo = /*#__PURE__*/ new WeakMap();
var $680188fe3fcbbe61$var$_disableScrolling = /*#__PURE__*/ new WeakMap();
class $680188fe3fcbbe61$var$CustomerConfig {
    get returnUrl() {
        return $680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_returnUrl);
    }
    /**
   * Set the returnUrl that should be followed when redirecting after login or logout
   * @param {string} localUrl - A string url to a local path.
   */ set returnUrl(localUrl) {
        $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_returnUrl, localUrl);
    }
    /**
   * True if the main navbar should be hidden. Always false if page is not framed.
   */ get hideNavbar() {
        return $680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_hideNavbar) && window !== window.parent;
    }
    /**
   * True if the customer logo should be hidden. Always false if page is not framed.
   */ get hideLogo() {
        return $680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_hideLogo) && window !== window.parent;
    }
    /**
   * True if scrolling should be disabled. Always false if page is not framed.
   */ get disableScrolling() {
        return $680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_disableScrolling) && window !== window.parent;
    }
    constructor(config){
        $680188fe3fcbbe61$var$_classPrivateFieldInitSpec(this, $680188fe3fcbbe61$var$_returnUrl, {
            writable: true,
            value: void 0
        });
        $680188fe3fcbbe61$var$_classPrivateFieldInitSpec(this, $680188fe3fcbbe61$var$_hideNavbar, {
            writable: true,
            value: void 0
        });
        $680188fe3fcbbe61$var$_classPrivateFieldInitSpec(this, $680188fe3fcbbe61$var$_hideLogo, {
            writable: true,
            value: void 0
        });
        $680188fe3fcbbe61$var$_classPrivateFieldInitSpec(this, $680188fe3fcbbe61$var$_disableScrolling, {
            writable: true,
            value: void 0
        });
        if (config) {
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_returnUrl, config.returnUrl);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideNavbar, config.hideNavbar);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideLogo, config.hideLogo);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_disableScrolling, config.disableScrolling);
        } else {
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_returnUrl, "");
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideNavbar, false);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideLogo, false);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_disableScrolling, false);
        }
    }
    parseQueryString(url) {
        const i = url.indexOf("?");
        if (i > 0) {
            const query = url.substring(i).toLowerCase();
            const params = new URLSearchParams(query);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_returnUrl, params.get("returnurl") ?? "");
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideNavbar, params.get("hidenav") ?? false);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideLogo, params.get("hidelogo") ?? false);
            $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_disableScrolling, params.get("disablescrolling") ?? false);
        }
    }
    mergeConfig(other) {
        if (other.returnUrl) $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_returnUrl, other.returnUrl);
        if (other.hideNavbar) $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideNavbar, other.hideNavbar);
        if (other.hideLogo) $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_hideLogo, other.hideLogo);
        if (other.disableScrolling) $680188fe3fcbbe61$var$_classPrivateFieldSet(this, $680188fe3fcbbe61$var$_disableScrolling, other.disableScrolling);
    }
    /**
   * Creates a query string from the configuration without a preceding ?
   * Returns an empty string if there is no config.
   * @returns the query string
   */ toQueryString() {
        const queries = [];
        if ($680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_returnUrl)) queries.push(`ReturnUrl=${encodeURIComponent($680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_returnUrl))}`);
        if ($680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_hideNavbar)) queries.push("HideNav=true");
        if ($680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_hideLogo)) queries.push("HideLogo=true");
        if ($680188fe3fcbbe61$var$_classPrivateFieldGet(this, $680188fe3fcbbe61$var$_disableScrolling)) queries.push("DisableScrolling=true");
        return queries.join("&");
    }
}
module.exports.default = $680188fe3fcbbe61$var$CustomerConfig;

});

parcelRequire.register("4J1FS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $370ca9e6ac39df43$var$_domUtils = $370ca9e6ac39df43$var$_interopRequireDefault((parcelRequire("imrQw")));

var $370ca9e6ac39df43$var$_messagePoster = $370ca9e6ac39df43$var$_interopRequireDefault((parcelRequire("o3NoA")));
function $370ca9e6ac39df43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $370ca9e6ac39df43$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $370ca9e6ac39df43$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $370ca9e6ac39df43$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $370ca9e6ac39df43$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $370ca9e6ac39df43$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $370ca9e6ac39df43$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $370ca9e6ac39df43$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $370ca9e6ac39df43$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $370ca9e6ac39df43$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $370ca9e6ac39df43$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $370ca9e6ac39df43$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $370ca9e6ac39df43$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $370ca9e6ac39df43$var$_isActive = /*#__PURE__*/ new WeakMap();
/**
 * Resizer posts window height changes to the parent window
 * to enable the iframe to be resized and avoid a second level scroll bar.
 */ class $370ca9e6ac39df43$var$Resizer {
    constructor(){
        $370ca9e6ac39df43$var$_classPrivateFieldInitSpec(this, $370ca9e6ac39df43$var$_isActive, {
            writable: true,
            value: void 0
        });
        // The resizer is only active when the page is embedded in an iframe.
        if (window !== window.parent) $370ca9e6ac39df43$var$_classPrivateFieldSet(this, $370ca9e6ac39df43$var$_isActive, true);
    }
    init() {
        if ($370ca9e6ac39df43$var$_classPrivateFieldGet(this, $370ca9e6ac39df43$var$_isActive)) // Resize when the body height changes
        $370ca9e6ac39df43$var$_domUtils.default.onContentHeightChange($("body"), $370ca9e6ac39df43$var$_messagePoster.default.postHeight);
    }
    /**
   * Ensures the body has enough height to fit the given element.
   * This is most useful for absolutely positioned elements which
   * are outside of the normal page flow.
   */ fitElem(elem) {
        let padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
        if ($370ca9e6ac39df43$var$_classPrivateFieldGet(this, $370ca9e6ac39df43$var$_isActive)) {
            const $elem = elem instanceof jQuery ? elem : $(elem);
            // Allow one frame for the element to be drawn
            setTimeout(()=>{
                const top = $370ca9e6ac39df43$var$_domUtils.default.getElemTop($elem);
                const minBodyHeight = top + $elem.height() + padding;
                const bodyHeight = $370ca9e6ac39df43$var$_domUtils.default.getContentHeight($("body"));
                if (bodyHeight < minBodyHeight) $370ca9e6ac39df43$var$_messagePoster.default.postHeight(minBodyHeight);
            }, 0);
        }
    }
}
module.exports.default = $370ca9e6ac39df43$var$Resizer;

});

parcelRequire.register("bjIV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83d4500c00f20700$var$_domUtils = $83d4500c00f20700$var$_interopRequireDefault((parcelRequire("imrQw")));

var $83d4500c00f20700$var$_messagePoster = $83d4500c00f20700$var$_interopRequireDefault((parcelRequire("o3NoA")));
function $83d4500c00f20700$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $83d4500c00f20700$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $83d4500c00f20700$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $83d4500c00f20700$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $83d4500c00f20700$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $83d4500c00f20700$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $83d4500c00f20700$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
function $83d4500c00f20700$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $83d4500c00f20700$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $83d4500c00f20700$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $83d4500c00f20700$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $83d4500c00f20700$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $83d4500c00f20700$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $83d4500c00f20700$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $83d4500c00f20700$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $83d4500c00f20700$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
var $83d4500c00f20700$var$_useScrollToMessages = /*#__PURE__*/ new WeakMap();
var $83d4500c00f20700$var$_paused = /*#__PURE__*/ new WeakMap();
var $83d4500c00f20700$var$_defaultPadding = /*#__PURE__*/ new WeakMap();
var $83d4500c00f20700$var$_scrollWindowTo = /*#__PURE__*/ new WeakSet();
class $83d4500c00f20700$var$Scroller {
    constructor(){
        let useScrollToMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $83d4500c00f20700$var$_classPrivateMethodInitSpec(this, $83d4500c00f20700$var$_scrollWindowTo);
        $83d4500c00f20700$var$_classPrivateFieldInitSpec(this, $83d4500c00f20700$var$_useScrollToMessages, {
            writable: true,
            value: void 0
        });
        $83d4500c00f20700$var$_classPrivateFieldInitSpec(this, $83d4500c00f20700$var$_paused, {
            writable: true,
            value: void 0
        });
        $83d4500c00f20700$var$_classPrivateFieldInitSpec(this, $83d4500c00f20700$var$_defaultPadding, {
            writable: true,
            value: void 0
        });
        $83d4500c00f20700$var$_classPrivateFieldSet(this, $83d4500c00f20700$var$_useScrollToMessages, useScrollToMessages);
        $83d4500c00f20700$var$_classPrivateFieldSet(this, $83d4500c00f20700$var$_paused, false);
        $83d4500c00f20700$var$_classPrivateFieldSet(this, $83d4500c00f20700$var$_defaultPadding, 75);
    }
    pause() {
        $83d4500c00f20700$var$_classPrivateFieldSet(this, $83d4500c00f20700$var$_paused, true);
    }
    unpause() {
        $83d4500c00f20700$var$_classPrivateFieldSet(this, $83d4500c00f20700$var$_paused, false);
    }
    scrollToElemTop($elem, padding) {
        if ($83d4500c00f20700$var$_classPrivateFieldGet(this, $83d4500c00f20700$var$_paused)) return;
        padding = padding ?? $83d4500c00f20700$var$_classPrivateFieldGet(this, $83d4500c00f20700$var$_defaultPadding);
        // Wait until the next frame to scroll to allow time for redraw/reflow 
        setTimeout(()=>{
            const top = $83d4500c00f20700$var$_domUtils.default.getElemTop($elem);
            // Account for a fixed/sticky navbar
            const $navbar = $("#nav-wrap");
            const pos = $navbar.css("position");
            if (pos == "fixed" || pos == "sticky") padding += $navbar.outerHeight();
            this.scrollTo(top, padding);
        }, 0);
    }
    scrollTo(top, padding) {
        if ($83d4500c00f20700$var$_classPrivateFieldGet(this, $83d4500c00f20700$var$_paused)) return;
        padding = padding ?? $83d4500c00f20700$var$_classPrivateFieldGet(this, $83d4500c00f20700$var$_defaultPadding);
        if ($83d4500c00f20700$var$_classPrivateFieldGet(this, $83d4500c00f20700$var$_useScrollToMessages)) $83d4500c00f20700$var$_messagePoster.default.postScrollTo(top, padding);
        else $83d4500c00f20700$var$_classPrivateMethodGet(this, $83d4500c00f20700$var$_scrollWindowTo, $83d4500c00f20700$var$_scrollWindowTo2).call(this, top - padding);
    }
}
module.exports.default = $83d4500c00f20700$var$Scroller;
function $83d4500c00f20700$var$_scrollWindowTo2(top) {
    if ($83d4500c00f20700$var$_classPrivateFieldGet(this, $83d4500c00f20700$var$_paused)) return;
    window.scroll({
        top: top,
        behavior: "smooth"
    });
}

});

parcelRequire.register("bOJgc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89a778f9345eb20d$var$_router = $89a778f9345eb20d$var$_interopRequireDefault((parcelRequire("4Z8W0")));

var $89a778f9345eb20d$var$_appointmentsService = $89a778f9345eb20d$var$_interopRequireDefault((parcelRequire("bPqot")));

var $89a778f9345eb20d$var$_viewMessage = $89a778f9345eb20d$var$_interopRequireDefault((parcelRequire("arP3R")));
function $89a778f9345eb20d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $89a778f9345eb20d$var$_classPrivateMethodInitSpec(obj, privateSet) {
    $89a778f9345eb20d$var$_checkPrivateRedeclaration(obj, privateSet);
    privateSet.add(obj);
}
function $89a778f9345eb20d$var$_classPrivateFieldInitSpec(obj, privateMap, value) {
    $89a778f9345eb20d$var$_checkPrivateRedeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function $89a778f9345eb20d$var$_checkPrivateRedeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $89a778f9345eb20d$var$_classPrivateFieldSet(receiver, privateMap, value) {
    var descriptor = $89a778f9345eb20d$var$_classExtractFieldDescriptor(receiver, privateMap, "set");
    $89a778f9345eb20d$var$_classApplyDescriptorSet(receiver, descriptor, value);
    return value;
}
function $89a778f9345eb20d$var$_classApplyDescriptorSet(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}
function $89a778f9345eb20d$var$_classPrivateFieldGet(receiver, privateMap) {
    var descriptor = $89a778f9345eb20d$var$_classExtractFieldDescriptor(receiver, privateMap, "get");
    return $89a778f9345eb20d$var$_classApplyDescriptorGet(receiver, descriptor);
}
function $89a778f9345eb20d$var$_classExtractFieldDescriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}
function $89a778f9345eb20d$var$_classApplyDescriptorGet(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}
function $89a778f9345eb20d$var$_classPrivateMethodGet(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}
var $89a778f9345eb20d$var$_isReload = /*#__PURE__*/ new WeakMap();
var $89a778f9345eb20d$var$_firstLoad = /*#__PURE__*/ new WeakMap();
var $89a778f9345eb20d$var$_ui = /*#__PURE__*/ new WeakMap();
var $89a778f9345eb20d$var$_cacheUiElements = /*#__PURE__*/ new WeakSet();
var $89a778f9345eb20d$var$_bindEvents = /*#__PURE__*/ new WeakSet();
var $89a778f9345eb20d$var$_updateNavigationHistory = /*#__PURE__*/ new WeakSet();
var $89a778f9345eb20d$var$_refreshFooter = /*#__PURE__*/ new WeakSet();
var $89a778f9345eb20d$var$_interceptSubmit = /*#__PURE__*/ new WeakSet();
class $89a778f9345eb20d$var$PageRouter extends $89a778f9345eb20d$var$_router.default {
    constructor(){
        super(...arguments);
        $89a778f9345eb20d$var$_classPrivateMethodInitSpec(this, $89a778f9345eb20d$var$_interceptSubmit);
        $89a778f9345eb20d$var$_classPrivateMethodInitSpec(this, $89a778f9345eb20d$var$_refreshFooter);
        $89a778f9345eb20d$var$_classPrivateMethodInitSpec(this, $89a778f9345eb20d$var$_updateNavigationHistory);
        $89a778f9345eb20d$var$_classPrivateMethodInitSpec(this, $89a778f9345eb20d$var$_bindEvents);
        $89a778f9345eb20d$var$_classPrivateMethodInitSpec(this, $89a778f9345eb20d$var$_cacheUiElements);
        $89a778f9345eb20d$var$_classPrivateFieldInitSpec(this, $89a778f9345eb20d$var$_isReload, {
            writable: true,
            value: void 0
        });
        $89a778f9345eb20d$var$_classPrivateFieldInitSpec(this, $89a778f9345eb20d$var$_firstLoad, {
            writable: true,
            value: true
        });
        $89a778f9345eb20d$var$_classPrivateFieldInitSpec(this, $89a778f9345eb20d$var$_ui, {
            writable: true,
            value: void 0
        });
    }
    init() {
        $89a778f9345eb20d$var$_classPrivateMethodGet(this, $89a778f9345eb20d$var$_cacheUiElements, $89a778f9345eb20d$var$_cacheUiElements2).call(this);
        super.init($89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).body);
        $89a778f9345eb20d$var$_classPrivateMethodGet(this, $89a778f9345eb20d$var$_bindEvents, $89a778f9345eb20d$var$_bindEvents2).call(this);
    }
    async load(url) {
        let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let http_method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "GET";
        try {
            await super.load(url, data, http_method);
        } catch (error) {
            const vm = new $89a778f9345eb20d$var$_viewMessage.default({
                type: "alert",
                header: "Error",
                body: "There was an error loading the page, please reload the page try again. If this problem persists please contact the practice to report the issue."
            });
            vm.display();
            // Unexpected errors should propagate.
            throw error;
        }
    }
    async refreshNavbar() {
        try {
            const params = new URLSearchParams(window.location.search);
            let returnUrl = params.get("ReturnUrl") ?? this.page;
            // Don't redirect to login flow pages
            if (returnUrl.toLowerCase().startsWith("/account/")) returnUrl = "/";
            const content = await $89a778f9345eb20d$var$_appointmentsService.default.getNavbarNav(returnUrl);
            $89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).navbarNav.html(content);
            this.refreshIntercepts();
        } catch (errResp) {
            // Log any error response and continue
            console.error(errResp);
        }
    }
    refreshIntercepts() {
        super.refreshIntercepts();
        $89a778f9345eb20d$var$_classPrivateMethodGet(this, $89a778f9345eb20d$var$_interceptSubmit, $89a778f9345eb20d$var$_interceptSubmit2).call(this);
    }
    async refreshPage() {
        try {
            $89a778f9345eb20d$var$_classPrivateFieldSet(this, $89a778f9345eb20d$var$_isReload, true);
            await this.load(this.page);
        } catch (errResp) {
            console.error(errResp);
            alert("There was an error loading the page content, please reload the page and try again.");
        }
    }
}
module.exports.default = $89a778f9345eb20d$var$PageRouter;
function $89a778f9345eb20d$var$_cacheUiElements2() {
    $89a778f9345eb20d$var$_classPrivateFieldSet(this, $89a778f9345eb20d$var$_ui, {
        body: $("body"),
        navbar: $("#main-navbar"),
        navbarNav: $("#navbar-nav"),
        footerAttr: $("footer .attribution")
    });
}
function $89a778f9345eb20d$var$_bindEvents2() {
    $89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).body.on("content-loaded", async (e, _ref)=>{
        let url = _ref.url;
        // Ignore propagated routing events, we only care about 
        // full page navigation events directly triggered on the body.
        if (e.target != $89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).body[0]) return;
        // Consume the event so if there is more than one router
        // (e.g., in a modal) they don't both fire.
        e.stopPropagation();
        $89a778f9345eb20d$var$_classPrivateMethodGet(this, $89a778f9345eb20d$var$_updateNavigationHistory, $89a778f9345eb20d$var$_updateNavigationHistory2).call(this, url);
        await this.refreshNavbar();
        $89a778f9345eb20d$var$_classPrivateMethodGet(this, $89a778f9345eb20d$var$_refreshFooter, $89a778f9345eb20d$var$_refreshFooter2).call(this);
        this.refreshIntercepts();
    });
    $(window).on("popstate", async (e)=>{
        if (e.originalEvent.state) {
            const url = e.originalEvent.state;
            $89a778f9345eb20d$var$_classPrivateFieldSet(this, $89a778f9345eb20d$var$_isReload, true);
            this.load(url);
        }
    });
}
function $89a778f9345eb20d$var$_updateNavigationHistory2(url) {
    // Ignore the login/out flow when updating the navigation history
    const pathLower = url.pathname.toLowerCase();
    if (pathLower == "/account/loginsuccess" || pathLower == "/account/logoff" || pathLower == "/account/resetpasswordconfirmation") return;
    // this.page is used for refreshing and returnUrls
    // so it should be set after the account login flow
    // so we don't have login return url's directing
    // back to the login page again.
    this.page = url.pathname;
    if ($89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_firstLoad)) {
        history.replaceState(url.toString(), "", url);
        $89a778f9345eb20d$var$_classPrivateFieldSet(this, $89a778f9345eb20d$var$_firstLoad, false);
        return;
    }
    if (!$89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_isReload)) history.pushState(url.toString(), "", url);
    $89a778f9345eb20d$var$_classPrivateFieldSet(this, $89a778f9345eb20d$var$_isReload, false);
}
function $89a778f9345eb20d$var$_refreshFooter2() {
    if ($("img.needs-attribution").length > 0) $89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).footerAttr.removeClass("hidden");
    else $89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).footerAttr.addClass("hidden");
}
function $89a778f9345eb20d$var$_interceptSubmit2() {
    // Intercept form submission (includes the navbar logout form)
    let $forms = $89a778f9345eb20d$var$_classPrivateFieldGet(this, $89a778f9345eb20d$var$_ui).body.find("form");
    $forms.off("submit").on("submit", async (e)=>{
        e.preventDefault();
        const $form = $(e.currentTarget);
        await this.load($form.attr("action"), $form.serializeObject(), "POST");
    });
}

});

"use strict";

var $79b526905b4bba10$var$_viewMessages = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("4dCyA")));

var $79b526905b4bba10$var$_blockUi = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("5BUQw")));

var $79b526905b4bba10$var$_multiPageRegisterForm = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("bqdsi")));

var $79b526905b4bba10$var$_schedule = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("t9g9T")));

var $79b526905b4bba10$var$_appointmentConfirmation = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("dv63s")));

var $79b526905b4bba10$var$_customerConfig = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("8VCwX")));

var $79b526905b4bba10$var$_resizer = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("4J1FS")));

var $79b526905b4bba10$var$_scroller = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("bjIV2")));

var $79b526905b4bba10$var$_pageRouter = $79b526905b4bba10$var$_interopRequireDefault((parcelRequire("bOJgc")));
function $79b526905b4bba10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable import/extensions */ window.customerConfig = null;
window.resizer = null;
window.scroller = null;
window.setStyle = (css)=>{
    $(()=>{
        const $style = $(`<style></style>`);
        $style.text(css);
        $("head").append($style);
    });
};
window.displayViewMessages = (messages, selector)=>{
    $(()=>{
        const vm = new $79b526905b4bba10$var$_viewMessages.default();
        vm.parse(messages);
        if (!vm.empty) {
            selector = selector ?? "body";
            const $container = $(selector);
            vm.display($container);
            vm.scrollTo();
        }
    });
};
window.clearViewMessages = (selector)=>{
    const vm = new $79b526905b4bba10$var$_viewMessages.default();
    selector = selector ?? "body";
    const $container = $(selector);
    vm.clear($container);
};
window.initCommon = (config)=>{
    $(()=>{
        window.customerConfig = new $79b526905b4bba10$var$_customerConfig.default(config);
        // Apply config settings
        if (window.customerConfig.hideLogo) $(".logo-wrap").addClass("hidden");
        else $(".logo-wrap").removeClass("hidden");
        window.resizer = new $79b526905b4bba10$var$_resizer.default();
        window.resizer.init();
        window.scroller = new $79b526905b4bba10$var$_scroller.default(config.disableScrolling);
        // Messages are attached to the body on page load
        window.displayViewMessages($("body").attr("data-messages"));
    });
};
window.initPageRouter = (page, options)=>{
    $(async ()=>{
        window.pageOptions = options;
        window.pageRouter = new $79b526905b4bba10$var$_pageRouter.default();
        pageRouter.init();
        pageRouter.load(page);
    });
};
window.initLoginNavItem = ()=>{
    $(()=>{
        const $logoffLink = $("a.logoff");
        $logoffLink.off("click").on("click", (e)=>{
            e.preventDefault();
            $(".logout-form").first().submit();
        });
    });
};
window.initLoginPage = ()=>{
    $(()=>{
        const $frmLogin = $("#login-form");
        $frmLogin.on("submit", (e)=>{
            if (!$frmLogin.valid()) {
                e.preventDefault();
                return;
            }
            $79b526905b4bba10$var$_blockUi.default.blockWithId("login-register", "Authenticating...");
        });
    });
};
window.initLoginSuccessPage = ()=>{
    $(()=>{
        $(document).trigger("login-success");
    });
};
window.initRegisterPage = ()=>{
    $(()=>{
        const register = new $79b526905b4bba10$var$_multiPageRegisterForm.default();
        register.init();
        // Scroll to form top when moving between pages
        register.eventTarget.on("next-prev.register-form", (e)=>{
            window.scroller.scrollToElemTop(register.form);
        });
    });
};
window.initHomePage = ()=>{
    $(()=>{
        $(".appointments").DataTable({
            lengthChange: false,
            searching: false,
            order: [
                [
                    0,
                    "desc"
                ]
            ],
            responsive: true
        });
    });
};
window.initBookPage = async ()=>{
    $(async ()=>{
        const schedule = new $79b526905b4bba10$var$_schedule.default(window.pageOptions);
        await schedule.init();
    });
};
window.initAppointmentConfirmationPage = ()=>{
    $(()=>{
        const confirmation = new $79b526905b4bba10$var$_appointmentConfirmation.default();
        confirmation.init();
    });
};

})();
//# sourceMappingURL=app.js.map
